// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/font-awesome/css/font-awesome.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/simple-line-icons/css/simple-line-icons.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=%27black%27 height=%2724%27 viewBox=%270 0 24 24%27 width=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M7 10l5 5 5-5z%27/><path d=%27M0 0h24v24H0z%27 fill=%27none%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/img/lan.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Poppins", sans-serif;
}

.btn {
  outline: 0 !important;
  box-shadow: none !important;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  letter-spacing: 0.5px;
  transform: none !important;
  transform: initial !important;
}

a {
  color: #f18f3c !important;
  font-weight: 400 !important;
}

label {
  font-size: 14px !important;
  letter-spacing: 0.3px;
  padding-left: 2px;
}

.ainput-group,
.form-group {
  margin-bottom: 15px !important;
  color: gray;
}

.form-control {
  font-size: 15px !important;
  font-weight: 400;
  letter-spacing: 0.3px;
  padding: 6px 12px !important;
  border: 1px solid #ced4da !important;
}
.form-control:focus {
  border-color: #f18f3c;
}

.themeBtn {
  background-color: #f18f3c;
  border: 1px solid #f18f3c !important;
  background-image: none;
  color: #fff !important;
  font-size: 16px;
  margin: 20px auto 10px;
  width: 280px;
  display: block;
  height: 42px;
  font-weight: 600 !important;
  line-height: 42px;
  padding: 0 12px;
}
.themeBtn:hover {
  background-color: #f18f3c !important;
  background-image: none !important;
}

.themeBtn:focus,
.themeBtn:active,
.themeBtn.active,
.themeBtn:active:focus,
.themeBtn:active:hover,
.themeBtn.active:focus,
.themeBtn.active:hover {
  background-color: #f18f3c !important;
  background-image: none !important;
}

.validation-error {
  color: #f16667;
  font-size: 13px;
  margin-top: 3px;
  padding-left: 5px;
}

.fs-16 {
  font-size: 16px !important;
}

.table-responsive {
  overflow: visible !important;
  overflow: initial !important;
  overflow-x: auto !important;
  padding-bottom: 0 !important;
}

.table > thead > tr > th {
  font-size: 14px;
}

.footer {
  display: flex;
  justify-content: center;
}
.footer .copyright {
  float: none !important;
  float: initial !important;
  padding: 0 10px !important;
}
.footer .nav {
  float: none !important;
  float: initial !important;
  align-self: flex-end;
  padding-left: 10px !important;
}
.footer:after {
  display: none !important;
}
.footer a {
  color: #697ba0 !important;
}
.footer .lsWebsite {
  color: #31c5c7 !important;
}

.dropdown-menu .dropdown-item {
  outline: 0 !important;
  color: #9a9a9a !important;
}

.sideMenuLogo {
  width: 165px;
}

.main-panel[data=blue] {
  border-top: 2px solid #f18f3c;
}

.sidebar[data=blue] {
  background: linear-gradient(0deg, #fbd449 0%, #f4a03f 100%);
}

.sidebar .nav p {
  font-size: 14px;
  font-weight: 500;
}

.sidebar .nav i {
  margin-right: 8px;
}

.modal-header {
  border-bottom: 1px solid #e9ecef !important;
  padding: 18px 24px 14px !important;
}

.modal-title {
  color: white !important;
  font-size: 18px;
  font-weight: 500;
}

.modal .modal-header .close {
  color: #fd5d93 !important;
  padding: 10px 10px 5px !important;
}

.modal-body {
  padding-top: 16px !important;
}
.modal-body .form-control {
  color: #fff !important;
}

.modal-footer {
  padding: 14px 24px 14px !important;
  justify-content: flex-end !important;
}
.modal-footer .btn {
  margin-left: 12px !important;
  height: 36px;
  padding: 0 12px !important;
  line-height: 34px !important;
  border: 1px solid #f18f3c !important;
  border-radius: 6px !important;
}
.modal-footer .modalBtnCancel {
  background-color: transparent !important;
  border: 1px solid #a5a5a5 !important;
  background-image: none !important;
  color: #a5a5a5 !important;
}
.modal-footer .modalBtnCancel:hover {
  background-color: transparent !important;
  background-image: none !important;
  color: #a5a5a5 !important;
}
.modal-footer .modalBtnCancel:focus,
.modal-footer .modalBtnCancel:active,
.modal-footer .modalBtnCancel.active,
.modal-footer .modalBtnCancel:active:focus,
.modal-footer .modalBtnCancel:active:hover,
.modal-footer .modalBtnCancel.active:focus,
.modal-footer .modalBtnCancel.active:hover {
  background-color: transparent !important;
  background-image: none !important;
  color: #a5a5a5 !important;
}
.modal-footer .modalBtnSave {
  background-color: #f18f3c !important;
  border: 1px solid #f18f3c !important;
  background-image: none !important;
  color: #fff !important;
}
.modal-footer .modalBtnSave:hover {
  background-color: #f18f3c !important;
  background-image: none !important;
  color: #fff !important;
}
.modal-footer .modalBtnSave:focus,
.modal-footer .modalBtnSave:active,
.modal-footer .modalBtnSave.active,
.modal-footer .modalBtnSave:active:focus,
.modal-footer .modalBtnSave:active:hover,
.modal-footer .modalBtnSave.active:focus,
.modal-footer .modalBtnSave.active:hover {
  background-color: #f18f3c !important;
  background-image: none !important;
  color: #fff !important;
}

.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  flex-direction: column;
}

.companyLogo {
  width: 310px;
  display: block;
  margin: 8px auto 35px;
}

.authFormWrap {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  border: 2px solid #665f5f;
  border-radius: 1rem;
}
.authFormWrap .card {
  margin-bottom: 0;
  border-radius: 12px;
  padding-top: 1.5rem;
}
.authFormWrap .card label,
.authFormWrap .card .forgotPassword {
  color: #676767 !important;
}
.authFormWrap .card .card-header {
  padding: 22px 25px 0;
}
.authFormWrap .card .card-header .card-title {
  font-weight: 600;
  color: #f18f3c;
  font-size: 26px;
}
.authFormWrap .card .card-body {
  padding: 12px 25px 15px;
}
.authFormWrap .form-group {
  position: relative;
}
.authFormWrap .form-group .form-control {
  padding-left: 34px !important;
  color: #fff !important;
}
.authFormWrap .form-group .form-control:focus {
  border-color: #f18f3c !important;
}
.authFormWrap .form-group .formIcon {
  position: absolute;
  top: 12px;
  left: 12px;
  font-size: 14px;
  color: #b0b0b0;
}
.authFormWrap .form-group .lockIcon {
  font-size: 15px;
  top: 11.5px;
}
.authFormWrap .form-group .callIcon {
  top: 12.5px;
}
.authFormWrap .form-group .mailIcon {
  top: 11.5px;
}
.authFormWrap .form-group .showPassword {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #a0a0a0;
}
.authFormWrap .form-group .passwordField {
  padding-right: 35px !important;
}
.authFormWrap .themeBtn {
  margin: 30px auto !important;
}
.authFormWrap .createAccount {
  color: #808080 !important;
  display: block;
  margin: 0 auto 10px;
  width: 250px;
  text-align: center;
  letter-spacing: 0.3px;
}
.authFormWrap .createAccount span {
  color: #f18f3c !important;
  font-weight: 500;
}

.authFooter {
  width: 100%;
  max-width: 500px;
  margin: 12px auto;
  display: flex;
  justify-content: space-between;
  color: #bbb;
  font-size: 14px;
}
.authFooter a {
  color: #f6bb44 !important;
}

.tableFilterWrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px !important;
}
.tableFilterWrap .form-control {
  border-color: #676767 !important;
  color: #ddd !important;
}
.tableFilterWrap .form-control:focus {
  border-color: #f18f3c !important;
}

.addBtn {
  background-color: #f18f3c !important;
  border-color: #f18f3c !important;
  color: #fff !important;
  height: 38px;
  line-height: 38px !important;
  background-image: none !important;
  padding: 0 15px !important;
}
.addBtn:hover, .addBtn:focus, .addBtn:active, .addBtn:active:focus, .addBtn:active:hover {
  background-color: #f18f3c !important;
  background-image: none !important;
  color: #fff !important;
}

.addBtn.active {
  background-color: #f18f3c !important;
  background-image: none !important;
  color: #fff !important;
}
.addBtn.active:focus, .addBtn.active:hover {
  background-color: #f18f3c !important;
  background-image: none !important;
  color: #fff !important;
}

.viewBtn {
  background-color: transparent !important;
  background-image: none !important;
  border: 1px solid #887f77 !important;
  color: #fff !important;
  height: 32px;
  line-height: 30px !important;
  padding: 0 12px !important;
}
.viewBtn:hover {
  background-color: #737170 !important;
  background-image: none !important;
  color: #fff !important;
}

.viewBtn:focus,
.viewBtn:active,
.viewBtn.active,
.viewBtn:active:focus,
.viewBtn:active:hover,
.viewBtn.active:focus,
.viewBtn.active:hover {
  background-color: #f18f3c !important;
  background-image: none !important;
  color: #fff !important;
}

.stopBtn {
  background: transparent !important;
  border: 1px solid #f16667 !important;
  height: 32px;
  line-height: 30px !important;
  padding: 0 12px !important;
}
.stopBtn:hover {
  background-color: #f16667 !important;
  background-image: none !important;
  color: #fff !important;
}

.stopBtn:focus,
.stopBtn:active,
.stopBtn.active,
.stopBtn:active:focus,
.stopBtn:active:hover,
.stopBtn.active:focus,
.stopBtn.active:hover {
  background-color: #f16667 !important;
  background-image: none !important;
  color: #fff !important;
}

.licensesList li {
  background-color: transparent;
  border: 0;
  border-bottom: 1px solid #666;
  border-radius: 0 !important;
  display: flex;
  justify-content: space-between;
  padding: 18px 5px;
}
.licensesList li:first-child {
  padding-top: 15px;
}
.licensesList li:last-child {
  border-bottom: 0;
  padding-bottom: 15px;
}

.userInfo .card-header {
  padding-bottom: 10px !important;
  border-bottom: 1px solid #525252 !important;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.3px;
}
.userInfo .card-footer {
  border-top: 1px solid #525252 !important;
  display: flex;
  justify-content: space-between;
  padding: 20px 15px 22px !important;
}
.userInfo .card-footer .btn {
  margin: 0 0 0 20px;
  flex-shrink: 0;
}
.userInfo label {
  color: #f5f5f5 !important;
}

.card-chart .card-header .card-category {
  font-size: 15px;
  letter-spacing: 0.3px;
  margin-bottom: 8px !important;
}
.card-chart .card-header .card-title i {
  font-size: 22px !important;
  color: #f18f3c;
}

.dashboardCard {
  text-align: center;
  cursor: pointer;
}
.dashboardCard i {
  font-size: 36px;
  color: #f18f3c;
}
.dashboardCard h3 {
  font-size: 28px;
  margin: 15px 0 10px;
  font-weight: 600;
}
.dashboardCard p {
  margin-bottom: 5px;
  font-size: 15px;
  letter-spacing: 0.3px;
  font-weight: 500;
}

.custom-control-label::before,
.custom-control-label::after {
  border: #adb5bd solid 1px;
  top: -8px !important;
  width: 1rem !important;
  height: 1rem !important;
}

.custom-control-label::after {
  border: 0;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before,
.custom-control-input:active ~ .custom-control-label::before {
  background-color: #f18f3c;
  border-color: #f18f3c;
}

.saveBtn {
  background-color: #f18f3c !important;
  border: 1px solid #f18f3c !important;
  background-image: none !important;
  color: #fff !important;
  font-size: 16px !important;
}
.saveBtn:hover {
  background-color: #f18f3c !important;
  background-image: none !important;
  color: #fff !important;
}

.saveBtn:focus,
.saveBtn:active,
.saveBtn.active,
.saveBtn:active:focus,
.saveBtn:active:hover,
.saveBtn.active:focus,
.saveBtn.active:hover {
  background-color: #f18f3c !important;
  background-image: none !important;
  color: #fff !important;
}

.cancelBtn {
  background-color: transparent !important;
  border: 1px solid #a5a5a5 !important;
  background-image: none !important;
  color: #a5a5a5 !important;
  font-size: 16px !important;
}
.cancelBtn:hover {
  background-color: transparent !important;
  background-image: none !important;
  color: #a5a5a5 !important;
}

.cancelBtn:focus,
.cancelBtn:active,
.cancelBtn.active,
.cancelBtn:active:focus,
.cancelBtn:active:hover,
.cancelBtn.active:focus,
.cancelBtn.active:hover {
  background-color: transparent !important;
  background-image: none !important;
  color: #a5a5a5 !important;
}

.assetImg {
  height: 50px;
  width: 50px;
  object-fit: cover;
  border: 1px solid #909090;
  padding: 1px;
  border-radius: 6px;
  margin-right: 8px;
}

.newLabBtn {
  position: relative;
  left: 92%;
  padding: 0 14px;
  height: 40px;
  line-height: 40px;
  background-color: #f18f3c;
  border: 1px solid #f18f3c !important;
  background-image: none;
  font-size: 15px;
}
.newLabBtn:hover {
  background-color: #f18f3c !important;
  background-image: none !important;
}

.newLabBtn:focus,
.newLabBtn:active,
.newLabBtn.active,
.newLabBtn:active:focus,
.newLabBtn:active:hover,
.newLabBtn.active:focus,
.newLabBtn.active:hover {
  background-color: #f18f3c !important;
  background-image: none !important;
}

.tableInModal {
  margin-bottom: 0;
}

.tableInModal > thead > tr > th {
  color: #c0b2b2 !important;
  border-bottom: 2px solid #dee2e6;
  font-size: 14px;
  letter-spacing: 0.3px;
}

.tableInModal > tbody > tr > td {
  color: #676767 !important;
  border-top: 1px solid #dee2e6;
}

.tableInModal .viewBtn {
  color: #f18f3c !important;
}
.tableInModal .viewBtn:hover {
  color: #fff !important;
}
.tableInModal .viewBtn:focus,
.tableInModal .viewBtn:active,
.tableInModal .viewBtn.active,
.tableInModal .viewBtn:active:focus,
.tableInModal .viewBtn:active:hover,
.tableInModal .viewBtn.active:focus,
.tableInModal .viewBtn.active:hover {
  color: #fff !important;
}
.tableInModal .stopBtn {
  color: #f16667 !important;
}
.tableInModal .stopBtn:hover {
  color: #fff !important;
}
.tableInModal .stopBtn:focus,
.tableInModal .stopBtn:active,
.tableInModal .stopBtn.active,
.tableInModal .stopBtn:active:focus,
.tableInModal .stopBtn:active:hover,
.tableInModal .stopBtn.active:focus,
.tableInModal .stopBtn.active:hover {
  color: #fff !important;
}

.isAdminCheck .custom-control-label::before,
.isAdminCheck .custom-control-label::after {
  top: 5px !important;
}

.isAdminWrap label {
  margin-bottom: 0;
}
.isAdminWrap .isAdminCheck .custom-control-label::before,
.isAdminWrap .isAdminCheck .custom-control-label::after {
  top: 2px !important;
}

.designLabSidebar .nav {
  margin-top: 50px;
}

#sidebarMenu {
  position: absolute;
  left: 0;
  transform: translateX(-180px);
  transition: transform 250ms ease-in-out;
  z-index: 98;
  overflow: auto;
  scrollbar-color: rgba(103, 112, 210, 0.8) #bbb;
  scrollbar-width: thin;
}

#sidebarMenu::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background-color: #bbb;
}

#sidebarMenu::-webkit-scrollbar {
  width: 8px;
  background-color: #bbb;
}

#sidebarMenu::-webkit-scrollbar-thumb {
  border-radius: 0;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.8);
  background-color: rgba(103, 112, 210, 0.8);
}

.sidebarMenuInner li {
  list-style: none;
  color: #fff;
  padding: 11px 16px;
  font-size: 14px;
  cursor: pointer;
  position: relative;
  overflow: auto;
}

.designLabSidebar .sidebarMenuInner li i {
  margin-right: 3px;
}

.designLabSidebar .sidebarMenuInner li img {
  margin-right: 5px;
}

#sidebarMenu .sidebarMenuInner li p {
  display: none;
}

input[type=checkbox]:checked ~ #sidebarMenu {
  transform: translateX(0px);
  transition: transform 250ms ease-in-out;
}

input[type=checkbox]:checked ~ #sidebarMenu .sidebarMenuInner li {
  padding-right: 21px;
}

input[type=checkbox]:checked ~ #sidebarMenu .sidebarMenuInner li div {
  justify-content: flex-start !important;
}

input[type=checkbox]:checked ~ #sidebarMenu .sidebarMenuInner li p {
  display: inline;
  display: initial;
}

input[type=checkbox]:checked ~ #sidebarMenu .sidebarMenuInner li i {
  font-size: 23px;
  margin-right: 10px;
}

input[type=checkbox]:checked ~ #sidebarMenu .sidebarMenuInner li img {
  margin-right: 13px;
}

.designLabSidebarWrapper input[type=checkbox] {
  transition: all 0.3s;
  box-sizing: border-box;
  display: none;
}

.sidebarIconToggle {
  transition: all 0.3s;
  box-sizing: border-box;
  cursor: pointer;
  position: absolute;
  z-index: 100;
  height: 100%;
  width: 100%;
  top: 100px;
  left: 23px;
  height: 22px;
  width: 22px;
  margin-bottom: 0;
}

input[type=checkbox]:checked + .sidebarIconToggle {
  top: 95px;
}

.spinner {
  transition: all 0.3s;
  box-sizing: border-box;
  position: absolute;
  height: 3px;
  width: 100%;
  background-color: #fff;
}

.horizontal {
  transition: all 0.3s;
  box-sizing: border-box;
  position: relative;
  float: left;
  opacity: 1;
  margin-top: 3px;
}

.diagonal.part-1 {
  position: relative;
  transition: all 0.3s;
  box-sizing: border-box;
  float: left;
  transform: rotate(0deg);
  margin-top: 1px;
}

.diagonal.part-2 {
  transition: all 0.3s;
  box-sizing: border-box;
  position: relative;
  float: left;
  transform: rotate(0deg);
  margin-top: 3px;
}

input[type=checkbox]:checked ~ .sidebarIconToggle > .horizontal {
  transition: all 0.3s;
  box-sizing: border-box;
  opacity: 0;
}

input[type=checkbox]:checked ~ .sidebarIconToggle > .diagonal.part-1 {
  transition: all 0.3s;
  box-sizing: border-box;
  transform: rotate(135deg);
  margin-top: 9px;
}

input[type=checkbox]:checked ~ .sidebarIconToggle > .diagonal.part-2 {
  transition: all 0.3s;
  box-sizing: border-box;
  transform: rotate(-135deg);
  margin-top: -9px;
}

.sideMenuTooltip .tooltip.show {
  left: 125px !important;
  font-size: 14px;
}

.main-panel > .designLabSideMenuClosedPadding {
  padding-left: 0px !important;
  padding-right: 0 !important;
}

@media all and (min-width: 768px) and (max-width: 991.98px) {
  .main-panel > .content {
    padding-left: 15px !important;
  }
}
.uploadProfile {
  background: #fff !important;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 3px;
  cursor: pointer;
  width: 133px;
  height: 133px;
  border-radius: 6px;
  display: block;
  margin: 27px auto 15px;
  position: relative;
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
}
.uploadProfile img {
  height: 125px;
  width: 125px;
  border-radius: 4px;
  object-fit: contain;
}
.uploadProfile i {
  font-size: 16px;
  color: #999;
  width: 32px;
  height: 28px;
  line-height: 26px;
  position: absolute;
  bottom: -13px;
  left: 50.5px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  text-align: center;
  border-radius: 6px;
}

.checkBox {
  width: 20px;
  height: 20px;
  margin-right: 15px;
  cursor: pointer;
}

input[type=checkbox]:not(:checked) ~ #sidebarMenu .zoom-slider-wrap {
  display: none;
}

.truncate {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 150px;
}

.modal-content {
  position: relative;
}

.resizable-container {
  width: 100% !important;
}

.rawfields {
  height: 500px !important;
  max-height: inherit !important;
}

.jtk-draw-skeleton {
  outline: none;
}

.jtk-draw-handle {
  background-color: rgba(30, 30, 47, 0.3019607843);
  width: 5px !important;
  height: 5px !important;
}

.jtk-surface-selected-element {
  border: 1px dotted rgba(30, 30, 47, 0.3019607843) !important;
}

.cardGrid {
  width: 100%;
  flex: 0 0 25%;
  margin-bottom: 30px;
}

.labCard {
  height: 100%;
}
.labCard .card-header {
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px dashed #333;
  padding-bottom: 15px;
  font-size: 16px;
  font-weight: 500;
}
.labCard .card-body {
  padding-bottom: 0;
}
.labCard .card-body .list-group .list-group-item {
  background: transparent;
  border: none;
  border-bottom: 1px dashed #333;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 0;
  display: flex;
}
.labCard .card-body .list-group .list-group-item:last-child {
  border-bottom: none;
}
.labCard .card-body .list-group .list-group-item span {
  color: rgba(255, 255, 255, 0.6);
}
.labCard .card-body .list-group .list-group-item span:first-child {
  display: inline-block;
  width: 110px;
  position: relative;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.9);
}
.labCard .card-body .list-group .list-group-item span:first-child::after {
  content: ":";
  position: absolute;
  right: 0;
}
.labCard .card-body .list-group.teamCount li span {
  width: auto !important;
  margin-right: 10px;
}
.labCard .card-body .list-group.teamCount li button {
  color: #eb8a0d;
  text-decoration: underline;
}
.labCard .dropdown > button {
  padding: 0 8px;
  background: transparent !important;
  font-size: 18px;
}
.labCard .dropdown > button:focus, .labCard .dropdown > button:active:focus {
  background: transparent !important;
}
.labCard .viewBtn {
  padding: 0 18px !important;
}
.labCard .centerButton .viewBtn {
  padding: 0 24px !important;
  margin: 0 10px;
}
.labCard.uploadCard .card-img-top {
  height: 200px;
  object-fit: cover;
}
.labCard.uploadCard .badge {
  position: absolute;
  left: 10px;
  top: 10px;
  padding: 10px 20px;
  font-size: 16px;
  background-color: #eb8a0d;
  color: #fff;
}
.labCard.uploadCard .uploadInfo {
  padding: 0;
  list-style: none;
}
.labCard.uploadCard .uploadInfo li {
  border-bottom: 1px dashed #333;
  padding: 10px 0;
}
.labCard.uploadCard .uploadInfo li span {
  margin-right: 5px;
  font-size: 14px;
  color: #fff;
  width: auto;
  display: block;
}
.labCard.uploadCard .uploadInfo li span:first-child {
  width: 120px;
}
.labCard.uploadCard .uploadInfo li span:last-child {
  color: rgba(255, 255, 255, 0.7);
}
.labCard.uploadCard .para {
  color: rgba(255, 255, 255, 0.6);
}
.labCard.uploadCard .actionButton .viewBtn,
.labCard.uploadCard .actionButton .stopBtn {
  padding: 0px 24px !important;
  height: 36px !important;
  margin: 10px 8px 0px;
}
.labCard.uploadCard .actionButton .viewBtn i,
.labCard.uploadCard .actionButton .stopBtn i {
  margin-right: 5px;
}
.labCard.uploadCard .actionDrop {
  position: absolute;
  right: 10px;
  top: 10px;
}
.labCard.uploadCard .actionDrop > button {
  background-color: #333 !important;
  padding: 4px 16px;
}
.labCard.uploadCard .actionDrop > button:focus, .labCard.uploadCard .actionDrop > button:hover {
  background-color: #333 !important;
}
.labCard.uploadCard .actionDrop .dropdown-menu {
  padding: 0;
  min-width: 100px !important;
}
.labCard.uploadCard .actionDrop .dropdown-menu .dropdown-item {
  border-bottom: 1px dashed rgba(51, 51, 51, 0.1);
  color: #333 !important;
  font-size: 14px;
  padding: 6px 20px;
}
.labCard.uploadCard .actionDrop .dropdown-menu .dropdown-item i {
  font-size: 18px;
  margin-right: 6px !important;
}
.labCard.uploadCard .actionDrop .dropdown-menu .dropdown-item:last-child {
  border-bottom: none;
  color: #f16667 !important;
}

.appInfo .card-header span {
  font-size: 18px;
  font-weight: 600;
  display: block;
}
.appInfo .license_code {
  text-align: center;
  margin: 30px 0;
}
.appInfo .license_code img {
  width: 120px;
  margin: auto;
  display: block;
  margin-bottom: 30px;
}
.appInfo .license_code h2 {
  font-size: 18px;
}
.appInfo .license_code span {
  color: #f16667;
}
.appInfo .uptodate img {
  width: 100px;
  margin: auto;
  display: block;
  margin-bottom: 30px;
}
.appInfo .uptodate {
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  margin: 30px 0;
}

.cardLibrary {
  background: none !important;
  padding: 20px 10px;
  border-radius: 20px;
  height: 100%;
}
.cardLibrary .card-img-top {
  display: block;
  height: 120px;
  width: auto;
}
.cardLibrary .card-body {
  padding: 0;
}
.cardLibrary .card-body .card-title {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.1px;
  margin: 25px 0;
}
.cardLibrary .card-body .badge {
  width: 80%;
  display: block;
  margin: auto !important;
  font-size: 16px;
  padding: 12px 0;
  border-radius: 20px;
  font-weight: 600;
}
.cardLibrary .card-body .btnInstall {
  background: #eb8a0d;
  margin: 0;
  border-radius: 50px;
  margin: auto !important;
  width: 150px;
}
.cardLibrary .card-body .btnInstall:hover {
  background: rgba(235, 138, 13, 0.8) !important;
}

.userCard {
  height: 100%;
}
.userCard .card-img-top {
  max-height: 240px;
  object-fit: contain;
}
.userCard .badge.badge-success {
  background: rgba(91, 209, 159, 0.6) !important;
  color: #fff !important;
}
.userCard .badge.badge-danger {
  background: rgba(255, 66, 65, 0.6) !important;
  color: #fff !important;
  border-color: rgba(255, 66, 65, 0.6) !important;
}
.userCard .badge {
  position: absolute;
  right: 15px;
  top: 15px;
  font-size: 14px;
  font-weight: 600 !important;
  padding: 4px 8px;
}
.userCard .card-body .card-title {
  display: flex;
  justify-content: center;
  font-size: 18px;
  margin-bottom: 10px;
  text-transform: capitalize;
  font-weight: 600;
}
.userCard .card-body .card-title span {
  display: inline-block;
}
.userCard .card-body .card-title span i {
  margin-left: 15px !important;
  display: inline-block;
  cursor: pointer;
}
.userCard .card-body .card-title span i.edit {
  color: #eb8a0d;
}
.userCard .card-body .card-title span i.delete {
  color: #f86c6b !important;
}
.userCard .card-body .list-group .list-group-item {
  background: transparent;
  border: none;
  border-bottom: 1px dashed #333;
  padding-top: 10px;
  display: flex;
  padding-bottom: 10px;
}
.userCard .card-body .list-group .list-group-item:last-child {
  border-bottom: none;
}
.userCard .card-body .list-group .list-group-item span {
  color: rgba(255, 255, 255, 0.6);
}
.userCard .card-body .list-group .list-group-item span:first-child {
  display: inline-block;
  width: 105px;
  position: relative;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.9);
}
.userCard .card-body .list-group .list-group-item span:first-child::after {
  content: ":";
  position: absolute;
  right: 0;
}
.userCard .card-body .list-group .list-group-item span:last-child {
  word-break: break-all;
  text-align: right;
}
.userCard .card-body .list-group.teamCount li span {
  width: auto !important;
  margin-right: 10px;
}
.userCard .card-body .list-group.teamCount li button {
  color: #eb8a0d;
  text-decoration: underline;
}

.innerForm .form-group label {
  color: #fff !important;
}
.innerForm .form-group input:not([type=checkbox]),
.innerForm .form-group select {
  height: 50px;
  border-radius: 6px;
  color: rgba(255, 255, 255, 0.5) !important;
}
.innerForm .form-group input:not([type=checkbox])::placeholder,
.innerForm .form-group select::placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}
.innerForm .form-group input:not([type=checkbox]),
.innerForm .form-group select { /* Firefox */ /* Safari and Chrome */
  appearance: none;
}
.innerForm .form-group select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position-x: 98%;
  background-position-y: 12px;
}
.innerForm .input-group {
  border: 1px solid #ced4da !important;
  border-radius: 6px;
}
.innerForm .input-group input {
  border: none !important;
}
.innerForm .input-group input ~ .input-group-append {
  border: none !important;
}
.innerForm .input-group input ~ .input-group-append .input-group-text {
  border: none;
}
.innerForm .input-group input ~ .input-group-append .input-group-text i {
  color: #333;
  font-size: 20px;
}
.innerForm input:-webkit-autofill {
  -webkit-text-fill-color: rgba(51, 51, 51, 0.6) !important;
  box-shadow: 0 0 0 30px #fff inset !important;
  -webkit-box-shadow: 0 0 0 30px #fff inset !important;
}
.innerForm.innerCard .form-group label {
  color: rgba(255, 255, 255, 0.8) !important;
}
.innerForm.innerCard .form-group input,
.innerForm.innerCard .form-group select {
  color: rgba(255, 255, 255, 0.5) !important;
}
.innerForm.innerCard .form-group input::placeholder,
.innerForm.innerCard .form-group select::placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.userDetail {
  list-style-type: none !important;
}
.userDetail ul.dropdown-menu li {
  padding: 0;
}
.userDetail ul.dropdown-menu li button {
  color: #333 !important;
}

.checkBox_inline .form-group {
  margin-bottom: 0 !important;
}
.checkBox_inline .form-group .custom-control-label::before, .checkBox_inline .form-group .custom-control-label::after {
  top: 0 !important;
}

.LibraryColumn {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  grid-gap: 20px;
  margin: 0;
  margin-bottom: 30px;
}
.LibraryColumn .col {
  padding: 0;
}

.imageDropdown {
  width: 100%;
}
.imageDropdown .dropdown-toggle {
  background: transparent !important;
  border: 1px solid #ced4da !important;
  padding: 10px;
  width: 100%;
  text-align: left;
  font-weight: 400;
}
.imageDropdown .dropdown-toggle:focus {
  background: transparent !important;
}
.imageDropdown .dropdown-toggle img {
  width: 24px;
  margin-right: 10px;
}
.imageDropdown .dropdown-menu {
  padding: 0;
  background-color: #333;
  width: 100%;
}
.imageDropdown .dropdown-menu .dropdown-item {
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.4);
}
.imageDropdown .dropdown-menu .dropdown-item:last-child {
  border: none;
}
.imageDropdown .dropdown-menu .dropdown-item img {
  width: 24px;
  margin-right: 10px;
}

@media screen and (max-width: 1600px) {
  .cardGrid {
    flex: 0 0 33.33%;
  }
}
@media screen and (max-width: 1200px) {
  .cardGrid {
    flex: 0 0 50%;
  }
}
@media screen and (max-width: 1024px) {
  .login-page .loginRight {
    display: none !important;
  }
  .login-page .logoIcon {
    opacity: 0.05;
    right: -18%;
    top: -40px;
    width: 50%;
  }
}
@media screen and (max-width: 1366px) {
  .tableFilterWrap .nav-tabs {
    overflow-y: scroll;
  }
  .tableFilterWrap .nav-tabs li a {
    padding: 10px;
    font-size: 14px;
    white-space: nowrap;
  }
}
@media screen and (max-width: 991px) {
  .userDetail ul.dropdown-menu {
    position: absolute !important;
    background: #fff !important;
    margin: 0 !important;
  }
  .userDetail {
    list-style-type: none !important;
  }
  .userDetail::marker {
    list-style-type: none !important;
  }
  .userDetail ul.dropdown-menu li.nav-link {
    padding: 0 !important;
  }
  .userDetail ul.dropdown-menu li.nav-link button {
    margin: 0;
  }
  .main-panel > .navbar {
    padding-left: 0;
    padding-right: 0;
  }
  .sidebar,
  .off-canvas-sidebar {
    margin-top: 0px !important;
  }
  .designLabSidebarWrapper {
    z-index: 9999999;
  }
  .designLabSidebarWrapper .sidebarIconToggle {
    top: 24px;
    left: 30px;
  }
  .designLabSidebarWrapper input[type=checkbox]:checked + .sidebarIconToggle {
    top: 24px;
    left: 30px;
  }
  .designLabSidebarWrapper ~ .main-panel {
    z-index: 1;
  }
}
@media screen and (max-width: 767px) {
  .cardGrid {
    flex: 1 1 100%;
  }
}
.custom-node {
  position: relative;
  z-index: 9;
}

.connect {
  display: none;
}

.custom-node:hover .connect {
  display: block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  width: 30px;
  height: 30px;
  background-color: transparent;
}

.select-mode {
  cursor: crosshair;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

.jtk-surface {
  width: 100%;
  margin: 0 auto;
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.2) 1px, transparent 0px), linear-gradient(rgba(255, 255, 255, 0.2) 1px, transparent 0px);
}

.jtk-node {
  /* width: 100px; */
  text-align: center;
}

.jtk-overlay {
  background-color: white;
  padding: 7px;
  border-radius: 4px;
}

.jtk-node button {
  margin: 10px;
}

.colorButton {
  position: absolute;
  z-index: 1000;
  top: 50px;
  right: 101px;
  background-color: blue;
  padding: 12px;
  outline: 0;
  border: none;
  color: white;
  border-radius: 7px;
  box-shadow: 2px 2px 10px grey;
}

/* custom */
.editBtn {
  top: 120px;
  right: 101px;
}

.jtk-group.jtk-drag-hover,
.jtk-node.jtk-drag-hover {
  outline: 2px solid red;
}

#drawing {
  background-size: 20px 20px;
  background-color: rgba(0, 0, 0, 0.08);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.2) 1px, transparent 0px), linear-gradient(rgba(255, 255, 255, 0.2) 1px, transparent 0px);
}

.zoom-range {
  position: absolute;
  z-index: 1000;
  top: 180px;
  right: 101px;
}

.jtk-surface.jtk-drag-drop-active,
.jtk-node.jtk-drag-drop-active,
.jtk-group.jtk-drag-drop-active {
  outline: 4px solid purple;
}

svg.jtk-drag-drop-active path {
  stroke: purple;
}

.deleteBtn {
  top: 240px;
  right: 101px;
}

.selectModeBtn {
  top: 310px;
  right: 101px;
}

.updateLinkBtn {
  top: 370px;
  right: 101px;
}

.adjust-minimize-icon {
  position: absolute;
  right: 45px;
  top: 20px;
  font-size: 15px;
  color: #000;
}

.custom-modal {
  position: fixed;
  top: 0;
  left: 25%;
  z-index: 1050;
  background: white;
  width: 50%;
}

.minimised-modal-list {
  background: #fff;
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 10px;
  display: flex;
}

.minimised-modal-item {
  align-items: flex-start;
  margin-right: 10px;
  padding: 5px;
  border: 1px solid #222;
  border-radius: 4px;
}

.jtk-connector {
  z-index: 9;
}

.jtk-hover {
  /* box-shadow: 2px 2px 19px #e0e0e0; */
}

.jtk-draw-skeleton {
  z-index: 10;
}

.controls i {
  background-color: rgba(38, 38, 38, 0.7);
  border-radius: 4px;
  cursor: pointer;
  margin-right: 5px;
  border: 1px solid white;
  font-size: 18px;
  font-style: normal;
  width: 30px;
  height: 30px;
  text-align: center;
  padding: 5px 5px;
}

.controls .selected-mode {
  background-color: #f18f3c !important;
  color: #fff !important;
}

.card-Feed {
  border: 0;
  box-shadow: rgba(2, 8, 20, 0.1) 0px 0.175em 0.5em, rgba(2, 8, 20, 0.08) 0px 0.085em 0.175em;
  margin: 15px 0;
  border-radius: 8px;
}

.card-Feed .card-header {
  background: #fff;
  padding: 10px 8px 8px 8px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  color: #3c4b64;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-color: rgba(0, 0, 0, 0.1);
  letter-spacing: 0.3px;
  background-color: #f0f3f5;
  background: rgba(145, 117, 224, 0.15);
}

.card-Feed .card-header h4 {
  margin-bottom: 0;
  font-size: 17px;
}

.card-Feed .card-header .profileID {
  font-size: 15px;
  color: #1F1F1F;
  text-decoration: none !important;
  cursor: pointer;
}

.postTime-Feed,
.lastSeen-Feed {
  color: #b1b1b1;
  font-size: 14px;
  letter-spacing: inherit;
  margin-left: 10px;
}

.postTime-Feed {
  color: #888;
  text-align: center;
}

.card-Feed .card-body {
  padding: 10px 8px 0;
}

.card-Feed .card-text {
  font-size: 15px;
  letter-spacing: 0.5px;
  color: #3c4b64;
  margin-bottom: 10px;
}

.mediaPhotoWrap-Feed,
.mediaVideoWrap-Feed {
  max-width: 100%;
  width: 100%;
  max-height: 100%;
  overflow: hidden;
  border-radius: 2px;
  margin-bottom: 10px;
  box-shadow: 0 1px 1px 0 rgba(60, 75, 100, 0.14), 0 2px 1px -1px rgba(60, 75, 100, 0.12), 0 1px 3px 0 rgba(60, 75, 100, 0.2);
}

.mediaPhotoWrap-Feed .carousel .carousel-item img,
.mediaPhotoWrap-Feed .carousel .carousel-item video {
  height: 375px;
  width: 100%;
}

.mediaPhotoWrap-Feed .carousel .carousel-item img {
  object-fit: cover;
  object-fit: contain;
}

.mediaPhoto-Feed {
  border-radius: 2px;
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  height: 375px;
  object-fit: cover;
  object-fit: contain;
  background: #f5f5f5;
}

.options-Feed {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px 0;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  margin: 0 -8px;
  background-color: #f0f3f5;
}

.options-Feed span {
  color: #1F1F1F;
}

.options-Feed .btn {
  padding: 6px 12px;
  line-height: 1;
  font-size: 16px;
  border: 1px solid transparent !important;
  background: transparent !important;
  box-shadow: none !important;
}

.options-Feed .btn i {
  margin-right: 8px;
  vertical-align: -1px;
  margin-top: 0 !important;
}

.carousel-control-prev,
.carousel-control-next {
  width: 9%;
  height: 20%;
  top: 40%;
}

audio:focus {
  outline: 0;
}

.carousel-control-next-icon,
.carousel-control-prev-icon {
  cursor: pointer;
}

.customDropdown-Feed .nav-link {
  color: #c8ced3;
  padding: 6px 12px;
  line-height: 1;
  font-size: 16px;
  border: 1px solid transparent !important;
  background: transparent !important;
  box-shadow: none !important;
}

.customDropdown-Feed .nav-link:hover {
  color: #23282c;
}

.pollOptionWrap label {
  color: #777;
  font-size: 15px;
  letter-spacing: 0.3px;
}

.create-post-txt {
  margin-bottom: 0;
  color: #3c4b64;
  letter-spacing: 0.3px;
}

.fansImgWrap {
  min-width: 36px;
  min-height: 36px;
  width: 36px;
  height: 36px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
  border-radius: 50%;
  padding: 2px;
  margin-right: 8px;
}

.fansImg {
  width: 30px;
  min-width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}

.msgPreviewWrap {
  width: calc(100% - 50px);
  left: 0;
  top: 0;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  background: #fff;
  padding: 8px 2px;
  scrollbar-color: rgba(95, 66, 170, 0.6) #bbb;
  scrollbar-width: thin;
  align-items: center;
  justify-content: flex-start;
  background: transparent;
}

.msgPreview {
  width: 56px;
  height: 56px;
  min-width: 56px;
  max-width: 56px;
  padding: 2px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  position: relative;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.msgPreview-media {
  width: 50px;
  min-width: 50px;
  max-width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
}

.deletePreview {
  position: absolute;
  padding: 4px 3px 2px;
  font-size: 13px;
  border-radius: 50%;
  top: -7px;
  right: -5px;
  line-height: 1;
  background: #de2727 !important;
  box-shadow: none !important;
  outline: 0 !important;
  color: #fff !important;
  border: 0;
  text-align: center;
}

.msgPreviewWrap::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background-color: #bbb;
}

.msgPreviewWrap::-webkit-scrollbar {
  background-color: #bbb;
  height: 6px;
}

.msgPreviewWrap::-webkit-scrollbar-thumb {
  border-radius: 0;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
  background-color: rgba(95, 66, 170, 0.6);
}

.messagePreview {
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 8px 20px 8px 8px;
  border-radius: 4px;
  position: relative;
  font-size: 16px;
  line-height: 1;
}

.postLocked,
.postUnlocked {
  position: relative;
}

.postLockedOverlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border: 1px solid #7e57c2;
}

.commentSection {
  background: #fff;
  margin-bottom: 15px;
  border-radius: 4px;
  padding: 18px 10px 12px;
  margin-top: -5px;
  box-shadow: 0 1px 1px 0 rgba(60, 75, 100, 0.14), 0 2px 1px -1px rgba(60, 75, 100, 0.12), 0 1px 3px 0 rgba(60, 75, 100, 0.2);
  max-height: 380px;
  overflow: auto;
  scrollbar-color: rgba(95, 66, 170, 0.8) #bbb;
  scrollbar-width: thin;
}

.commentSection::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background-color: #bbb;
}

.commentSection::-webkit-scrollbar {
  width: 8px;
  background-color: #bbb;
}

.commentSection::-webkit-scrollbar-thumb {
  border-radius: 0;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
  background-color: rgba(95, 66, 170, 0.8);
}

.personImg-Comment {
  min-width: 32px;
  min-height: 32px;
  width: 32px;
  height: 32px;
  border: 1px solid #e0e0e0;
  border-radius: 50%;
  margin-right: 8px;
  font-size: 14px;
  color: #3c4b64;
}

.commentSection .form-control {
  background: #f5f8fd;
}

.comments-Post {
  background: #f5f5f5;
  border-radius: 4px;
  padding: 6px;
  font-size: 14px;
  color: #3c4b64;
  margin-bottom: 2px;
  border: 1px solid #eee;
}

.comments-Post p {
  font-size: 14px;
  font-size: 14px;
  color: #3c4b64;
  letter-spacing: 0.5px;
  margin-bottom: 0;
}

.commentOptions .nav-link {
  color: #888;
  padding: 6px;
  margin-left: 4px;
  border-radius: 50%;
  line-height: 1;
  font-size: 13px;
  background: transparent !important;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
  box-shadow: none !important;
}

.commentOptions .nav-link i {
  margin-top: 0 !important;
}

.replyBtn {
  font-size: 13px;
  color: #888;
  letter-spacing: 0.5px;
  padding: 4px 4px 2px;
  margin: 0;
  width: min-content;
  background: transparent !important;
  border: 0;
  box-shadow: none !important;
}

.commentTime {
  padding: 4px 0 2px;
  font-size: 13px;
  color: #888;
  letter-spacing: 0.5px;
  margin-left: 15px;
  position: relative;
}

.commentTime:before {
  position: absolute;
  top: 4px;
  left: -12px;
}

.videoPlayBtn {
  height: 50px;
  width: 50px;
  line-height: 1;
  border: 1px solid #1F1F1F !important;
  border-radius: 50%;
  color: #1F1F1F !important;
  font-size: 22px;
  background: #fff !important;
  box-shadow: 0 1px 1px 0 rgba(60, 75, 100, 0.14), 0 2px 1px -1px rgba(60, 75, 100, 0.12), 0 1px 3px 0 rgba(60, 75, 100, 0.2) !important;
}

.videoPlayBtn i {
  margin-top: 0 !important;
  margin-left: 3px;
}

.ml-0 {
  margin-left: 0 !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.capitalize {
  text-transform: capitalize;
}

a {
  color: inherit;
  text-decoration: none;
}
a:hover {
  color: inherit;
  text-decoration: none;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  border-radius: 10px;
}

/* Handle */
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #8c8c8c;
}

.custom-context-menu {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.custom-context-menu li {
  padding: 7px 10px;
  cursor: pointer;
  color: #222;
  border-bottom: 1px solid rgba(204, 204, 204, 0.8);
}
.custom-context-menu li:hover {
  background-color: rgba(204, 204, 204, 0.8);
}
.custom-context-menu li:last-child {
  border-bottom: 0;
}

.lab-name {
  position: absolute;
  left: 40%;
  font-size: 24px;
  color: #f6bb44;
}

.editor-wrapper {
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
}

.import-btn {
  position: relative;
  height: 38px;
  cursor: pointer;
}
.import-btn .file-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  opacity: 0;
  cursor: pointer;
}

.disable-action {
  opacity: 0.5;
  background: rgba(221, 221, 221, 0.4705882353);
  pointer-events: none;
}

.lab-edit-icon {
  color: #f5ab41;
  cursor: pointer;
  margin-right: 1rem;
  float: right;
}

.custom-select-section {
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.flexible-modal {
  position: absolute;
  z-index: 1;
  border: 1px solid #ccc;
  background: white;
}

.flexible-modal-mask {
  position: fixed;
  height: 100%;
  background: rgba(55, 55, 55, 0);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.flexible-modal-resizer {
  position: absolute;
  right: 0;
  bottom: 0;
  cursor: se-resize;
  margin: 5px;
  border-bottom: solid 2px #333;
  border-right: solid 2px #333;
}

.flexible-modal-drag-area {
  color: #222;
  height: 50px;
  position: absolute;
  right: 0;
  top: 0;
  cursor: move;
}

@media screen and (min-width: 991px) {
  .navbar .navbar-brand {
    margin-top: 15px;
  }
}
.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: white;
  background-color: #171717;
  border: 1px solid #f18f3c;
}

.page-item.disabled .page-link {
  background-color: transparent;
  border-color: #f18f3c;
}

.page-link:hover {
  z-index: 2;
  color: #27293d;
  text-decoration: none;
  background-color: #f18f3c;
  border-color: #f18f3c;
}

.page-item.active .page-link {
  z-index: 1;
  color: #ffffff;
  background-color: #f18f3c;
  border-color: #f18f3c;
}

.zoom-slider-wrap {
  position: absolute;
  left: 25px;
  bottom: 15px;
  display: flex;
}

.adv-check-wrap {
  display: flex;
  justify-content: flex-end;
}
.adv-check-wrap .checkbox-wrap {
  margin-top: 2px;
}

.group-by-wrap {
  margin-bottom: 20px;
}
.group-by-wrap select {
  width: 100px;
  display: inline-block;
}

.sidebar[data=blue] {
  background: linear-gradient(0deg, #151515 0%, #151515 100%);
}

body {
  background-color: #141414;
  color: rgba(255, 255, 255, 0.8);
  font-family: "Roboto Mono", monospace;
}

.main-panel {
  background: #141414;
}

.card {
  background: none;
  border: 1px solid #222322;
}

.modal .page-link {
  background-color: #fff;
  color: #222;
}

.dashboard-docker-icon {
  width: 37px;
  margin: 0 auto;
}

.lab-menu-img {
  width: 30px;
  margin-right: 12px;
}

.connection-info-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.connection-info-wrap .info {
  text-align: center;
  width: 30%;
  position: relative;
}
.connection-info-wrap .info i {
  font-size: 40px;
}

.port-form-wrap {
  display: flex;
  justify-content: space-between;
}
.port-form-wrap .form-group {
  width: 45%;
}

.delete-link-icon {
  color: #e68539;
  cursor: pointer;
  text-decoration: underline;
}

@keyframes beat {
  to {
    transform: scale(1.1);
  }
}
.processing-node-wrap {
  animation: beat 0.25s infinite alternate;
  pointer-events: none;
}

.custom-guacamole-modal {
  z-index: 9999;
  border-radius: 20px;
  box-shadow: 10px 5px 30px #222;
}
.custom-guacamole-modal .body {
  background-color: #fff;
}
.custom-guacamole-modal .modal-footer {
  background-color: #fff;
  color: #222;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
}

.action-menu-img {
  width: 22px;
  margin: 0px -3px 0 -3px;
  float: left;
}

.color-preview {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 1px dashed rgb(34, 34, 34);
  margin: -1px 0 0 10px;
  vertical-align: middle;
}

.change-pwd-eye-icon {
  position: absolute;
  right: 10px;
  top: 36px;
  cursor: pointer;
  color: #f18f3c;
  font-size: 16px;
}

.profile-item-wrap {
  margin: 0;
}
.profile-item-wrap .profile-item {
  border: 1px solid #ced4da;
  text-align: center;
  margin: 0 10px 10px 0;
  width: 75px;
  height: 75px;
  justify-content: center;
  align-items: center;
  display: flex;
  border-radius: 4px;
  flex-direction: column;
  padding: 5px;
  transition: all 0.2s;
  cursor: pointer;
  font-size: 12px;
  position: relative;
}
.profile-item-wrap .profile-item .profile-name {
  line-height: 16px;
  margin-top: 8px;
}
.profile-item-wrap .active-profile-item {
  border-color: #f18f3c;
  color: #f18f3c;
}

.emulation-fields {
  display: flex;
  justify-content: space-between;
}
.emulation-fields .form-group {
  width: 47%;
}

.emulation-item-wrap {
  display: flex;
  justify-content: space-between;
  border: 1px solid #f18f3c;
  border-radius: 4px;
  padding: 9px;
}

.emulation-items {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.emulation-del-icon {
  justify-content: center;
  color: red;
  cursor: pointer;
  font-size: 18px;
}

.remove-profile-icon {
  position: absolute;
  top: -6px;
  right: -6px;
  color: red;
  font-size: 15px;
  background: #fff;
}

.custom-tag {
  position: absolute;
  width: 18px;
  left: 0px;
  top: -3px;
}

.side-menu-img {
  width: 25px;
  margin: 4px 12px 0 6px;
  float: left;
}

.flexible-modal-drag-area-right,
.flexible-modal-drag-area-left {
  display: none;
}

body.no-scroll {
  overflow: hidden;
}

@keyframes blink {
  50% {
    border-color: #f18f3c;
    border-width: 4px;
  }
}
.active-guacamole-modal {
  border-color: #f18f3c;
  border-width: 4px;
}

.adjust-minimize-icon {
  position: absolute;
  right: 45px;
  top: 20px;
  font-size: 15px;
  color: #000;
  cursor: pointer;
  z-index: 9;
}

.otp-text {
  color: #222;
}

.full-page-modal {
  max-width: calc(100vw - 10%) !important;
}

.full-page-modal .modal-body {
  padding: 2px !important;
}

.drawing-board-container {
  width: 100% !important;
}

.drawing-board-toolbar-iconLabel {
  line-height: 13px;
}

.drawing-board-toolbar-icon:last-child {
  display: none;
}

.drawing-item-wrap {
  height: 100vh;
}
.drawing-item-wrap h4 {
  color: white !important;
}

.drawing-item {
  padding: 10px;
  border: 1px solid orange;
  margin: 10px;
  border-radius: 10px;
  width: 23%;
  display: inline-block;
  vertical-align: top;
}
.drawing-item img {
  object-fit: contain;
}

.drawing-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}
.drawing-info h4 {
  color: #222 !important;
}
.drawing-info i {
  cursor: pointer;
}

.drawing-name {
  width: 250px;
  margin: 10px;
}
.no-drawings {
  text-align: center;
  padding-top: 20%;
}

.footer .orange-text {
  color: #f6bb44 !important;
}`, "",{"version":3,"sources":["webpack://./src/scss/_custom.scss","webpack://./src/App.scss","webpack://./src/scss/js-plumb.scss","webpack://./src/scss/web-app.scss"],"names":[],"mappings":"AAgBA;EACE,kCAAA;ACZF;;ADeA;EACE,qBAAA;EACA,2BAAA;EACA,kCAAA;EACA,gBAAA;EACA,qBAAA;EACA,0BAAA;EAAA,6BAAA;ACZF;;ADeA;EACE,yBAAA;EACA,2BAAA;ACZF;;ADeA;EACE,0BAAA;EACA,qBAAA;EACA,iBAAA;ACZF;;ADeA;;EAEE,8BAAA;EACA,WAAA;ACZF;;ADeA;EACE,0BAAA;EACA,gBAAA;EACA,qBAAA;EACA,4BAAA;EACA,oCAAA;ACZF;ADcE;EACE,qBAAA;ACZJ;;ADgBA;EACE,yBAAA;EACA,oCAAA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,2BAAA;EACA,iBAAA;EACA,eAAA;ACbF;ADeE;EACE,oCAAA;EACA,iCAAA;ACbJ;;ADiBA;;;;;;;EAOE,oCAAA;EACA,iCAAA;ACdF;;ADiBA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;ACdF;;ADiBA;EACE,0BAAA;ACdF;;ADiBA;EACE,4BAAA;EAAA,4BAAA;EACA,2BAAA;EACA,4BAAA;ACdF;;ADiBA;EACE,eAAA;ACdF;;ADiBA;EACE,aAAA;EAEA,uBAAA;ACfF;ADmBE;EACE,sBAAA;EAAA,yBAAA;EACA,0BAAA;ACjBJ;ADoBE;EACE,sBAAA;EAAA,yBAAA;EACA,oBAAA;EACA,6BAAA;AClBJ;ADqBE;EACE,wBAAA;ACnBJ;ADsBE;EACE,yBAAA;ACpBJ;ADuBE;EACE,yBAAA;ACrBJ;;AD+BA;EACE,qBAAA;EACA,yBAAA;AC5BF;;AD+BA;EACE,YAAA;AC5BF;;AD+BA;EACE,6BAAA;AC5BF;;AD+BA;EACE,2DAAA;AC5BF;;AD+BA;EACE,eAAA;EACA,gBAAA;AC5BF;;AD+BA;EACE,iBAAA;AC5BF;;AD+BA;EACE,2CAAA;EACA,kCAAA;AC5BF;;AD+BA;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;AC5BF;;AD+BA;EACE,yBAAA;EACA,iCAAA;AC5BF;;AD+BA;EACE,4BAAA;AC5BF;AD8BE;EACE,sBAAA;AC5BJ;;ADgCA;EACE,kCAAA;EACA,oCAAA;AC7BF;AD+BE;EACE,4BAAA;EACA,YAAA;EACA,0BAAA;EACA,4BAAA;EACA,oCAAA;EACA,6BAAA;AC7BJ;ADgCE;EACE,wCAAA;EACA,oCAAA;EACA,iCAAA;EACA,yBAAA;AC9BJ;ADgCI;EACE,wCAAA;EACA,iCAAA;EACA,yBAAA;AC9BN;ADkCE;;;;;;;EAOE,wCAAA;EACA,iCAAA;EACA,yBAAA;AChCJ;ADmCE;EACE,oCAAA;EACA,oCAAA;EACA,iCAAA;EACA,sBAAA;ACjCJ;ADmCI;EACE,oCAAA;EACA,iCAAA;EACA,sBAAA;ACjCN;ADqCE;;;;;;;EAOE,oCAAA;EACA,iCAAA;EACA,sBAAA;ACnCJ;;ADuCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;ACpCF;;ADuCA;EACE,YAAA;EACA,cAAA;EACA,qBAAA;ACpCF;;ADuCA;EACE,WAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;ACpCF;ADwCE;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;ACtCJ;ADwCI;;EAEE,yBAAA;ACtCN;ADyCI;EACE,oBAAA;ACvCN;ADyCM;EACE,gBAAA;EACA,cAAA;EACA,eAAA;ACvCR;AD2CI;EACE,uBAAA;ACzCN;AD6CE;EACE,kBAAA;AC3CJ;AD6CI;EACE,6BAAA;EACA,sBAAA;AC3CN;AD8CM;EACE,gCAAA;AC5CR;ADgDI;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;AC9CN;ADiDI;EACE,eAAA;EACA,WAAA;AC/CN;ADkDI;EACE,WAAA;AChDN;ADmDI;EACE,WAAA;ACjDN;ADoDI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;AClDN;ADqDI;EACE,8BAAA;ACnDN;ADuDE;EACE,4BAAA;ACrDJ;ADwDE;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;ACtDJ;ADwDI;EACE,yBAAA;EACA,gBAAA;ACtDN;;AD2DA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;ACxDF;AD0DE;EACE,yBAAA;ACxDJ;;AD4DA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,+BAAA;ACzDF;AD2DE;EACE,gCAAA;EACA,sBAAA;ACzDJ;AD2DI;EACE,gCAAA;ACzDN;;AD8DA;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;EACA,YAAA;EACA,4BAAA;EACA,iCAAA;EACA,0BAAA;AC3DF;AD6DE;EAKE,oCAAA;EACA,iCAAA;EACA,sBAAA;AC/DJ;;ADmEA;EACE,oCAAA;EACA,iCAAA;EACA,sBAAA;AChEF;ADkEE;EAEE,oCAAA;EACA,iCAAA;EACA,sBAAA;ACjEJ;;ADqEA;EACE,wCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sBAAA;EACA,YAAA;EACA,4BAAA;EACA,0BAAA;AClEF;ADoEE;EACE,oCAAA;EACA,iCAAA;EACA,sBAAA;AClEJ;;ADsEA;;;;;;;EAOE,oCAAA;EACA,iCAAA;EACA,sBAAA;ACnEF;;ADsEA;EACE,kCAAA;EACA,oCAAA;EACA,YAAA;EACA,4BAAA;EACA,0BAAA;ACnEF;ADqEE;EACE,oCAAA;EACA,iCAAA;EACA,sBAAA;ACnEJ;;ADuEA;;;;;;;EAOE,oCAAA;EACA,iCAAA;EACA,sBAAA;ACpEF;;ADuEA;EACE,6BAAA;EACA,SAAA;EACA,6BAAA;EACA,2BAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;ACpEF;ADsEE;EACE,iBAAA;ACpEJ;ADuEE;EACE,gBAAA;EACA,oBAAA;ACrEJ;;AD0EE;EACE,+BAAA;EACA,2CAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;ACvEJ;AD0EE;EACE,wCAAA;EACA,aAAA;EACA,8BAAA;EACA,kCAAA;ACxEJ;AD0EI;EACE,kBAAA;EACA,cAAA;ACxEN;AD4EE;EACE,yBAAA;AC1EJ;;AD+EE;EACE,eAAA;EACA,qBAAA;EACA,6BAAA;AC5EJ;AD+EE;EACE,0BAAA;EACA,cAAA;AC7EJ;;ADiFA;EACE,kBAAA;EACA,eAAA;AC9EF;ADiFE;EACE,eAAA;EACA,cAAA;AC/EJ;ADkFE;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;AChFJ;ADmFE;EACE,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;ACjFJ;;ADqFA;;EAEE,yBAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;AClFF;;ADqFA;EACE,SAAA;AClFF;;ADqFA;;EAEE,yBAAA;EACA,qBAAA;AClFF;;ADqFA;EACE,oCAAA;EACA,oCAAA;EACA,iCAAA;EACA,sBAAA;EACA,0BAAA;AClFF;ADoFE;EACE,oCAAA;EACA,iCAAA;EACA,sBAAA;AClFJ;;ADsFA;;;;;;;EAOE,oCAAA;EACA,iCAAA;EACA,sBAAA;ACnFF;;ADsFA;EACE,wCAAA;EACA,oCAAA;EACA,iCAAA;EACA,yBAAA;EACA,0BAAA;ACnFF;ADqFE;EACE,wCAAA;EACA,iCAAA;EACA,yBAAA;ACnFJ;;ADuFA;;;;;;;EAOE,wCAAA;EACA,iCAAA;EACA,yBAAA;ACpFF;;ADuFA;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;ACpFF;;ADuFA;EACE,kBAAA;EAGA,SAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,oCAAA;EACA,sBAAA;EACA,eAAA;ACtFF;ADwFE;EACE,oCAAA;EACA,iCAAA;ACtFJ;;AD0FA;;;;;;;EAOE,oCAAA;EACA,iCAAA;ACvFF;;AD0FA;EACE,gBAAA;ACvFF;;AD0FA;EACE,yBAAA;EACA,gCAAA;EACA,eAAA;EACA,qBAAA;ACvFF;;AD0FA;EACE,yBAAA;EACA,6BAAA;ACvFF;;AD2FE;EACE,yBAAA;ACxFJ;AD0FI;EACE,sBAAA;ACxFN;AD4FE;;;;;;;EAOE,sBAAA;AC1FJ;AD6FE;EACE,yBAAA;AC3FJ;AD6FI;EACE,sBAAA;AC3FN;AD+FE;;;;;;;EAOE,sBAAA;AC7FJ;;ADiGA;;EAEE,mBAAA;AC9FF;;ADkGE;EACE,gBAAA;AC/FJ;ADkGE;;EAEE,mBAAA;AChGJ;;ADiHA;EACE,gBAAA;AC9GF;;ADiHA;EACE,kBAAA;EACA,OAAA;EACA,6BAAA;EACA,uCAAA;EACA,WAAA;EACA,cAAA;EACA,8CAAA;EACA,qBAAA;AC9GF;;ADiHA;EACE,oDAAA;EACA,gBAAA;EACA,sBAAA;AC9GF;;ADiHA;EACE,UAAA;EACA,sBAAA;AC9GF;;ADiHA;EACE,gBAAA;EACA,oDAAA;EACA,0CAAA;AC9GF;;ADiHA;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AC9GF;;ADiHA;EACE,iBAAA;AC9GF;;ADiHA;EACE,iBAAA;AC9GF;;ADiHA;EACE,aAAA;AC9GF;;ADiHA;EACE,0BAAA;EACA,uCAAA;AC9GF;;ADiHA;EACE,mBAAA;AC9GF;;ADiHA;EACE,sCAAA;AC9GF;;ADiHA;EACE,eAAA;EAAA,gBAAA;AC9GF;;ADiHA;EACE,eAAA;EACA,kBAAA;AC9GF;;ADiHA;EACE,kBAAA;AC9GF;;ADiHA;EACE,oBAAA;EACA,sBAAA;EACA,aAAA;AC9GF;;ADiHA;EACE,oBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AC9GF;;ADiHA;EAGE,SAAA;AChHF;;ADmHA;EACE,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;AChHF;;ADmHA;EACE,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;AChHF;;ADmHA;EACE,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;AChHF;;ADmHA;EACE,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;AChHF;;ADmHA;EACE,oBAAA;EACA,sBAAA;EACA,UAAA;AChHF;;ADmHA;EACE,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;AChHF;;ADmHA;EACE,oBAAA;EACA,sBAAA;EACA,0BAAA;EACA,gBAAA;AChHF;;ADmHA;EACE,sBAAA;EACA,eAAA;AChHF;;ADmHA;EAEE,4BAAA;EACA,2BAAA;ACjHF;;ADoHA;EACE;IACE,6BAAA;ECjHF;AACF;ADyOA;EACE,2BAAA;EACA,oCAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,gDAAA;ACvOF;ADyOE;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;ACvOJ;AD0OE;EACE,eAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,oCAAA;EACA,kBAAA;EACA,kBAAA;ACxOJ;;AD2OA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;ACxOF;;AD2OA;EACE,aAAA;ACxOF;;AD2OA;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;ACxOF;;AD2OA;EACE,kBAAA;ACxOF;;AD2OA;EACE,sBAAA;ACxOF;;AD2OA;EACE,wBAAA;EACA,8BAAA;ACxOF;;AD2OA;EACE,aAAA;ACxOF;;AD2OA;EACE,gDAAA;EACA,qBAAA;EACA,sBAAA;ACxOF;;AD2OA;EACE,4DAAA;ACxOF;;AD8OA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;AC3OF;;AD8OA;EACE,YAAA;AC3OF;AD4OE;EACE,8BAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;AC1OJ;AD4OE;EACE,iBAAA;AC1OJ;AD4OM;EACE,uBAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,aAAA;AC1OR;AD2OQ;EACE,mBAAA;ACzOV;AD2OQ;EACE,+BAAA;ACzOV;AD0OU;EACE,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,+BAAA;ACxOZ;ADyOY;EACE,YAAA;EACA,kBAAA;EACA,QAAA;ACvOd;AD8OU;EACE,sBAAA;EACA,kBAAA;AC5OZ;AD8OU;EACE,cAvqCF;EAwqCE,0BAAA;AC5OZ;ADmPI;EACE,cAAA;EACA,kCAAA;EACA,eAAA;ACjPN;ADkPM;EAEE,kCAAA;ACjPR;ADsPE;EACE,0BAAA;ACpPJ;ADuPI;EACE,0BAAA;EACA,cAAA;ACrPN;ADyPI;EACE,aAAA;EACA,iBAAA;ACvPN;ADyPI;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,yBA9sCI;EA+sCJ,WA9sCE;ACu9BR;ADyPI;EACE,UAAA;EACA,gBAAA;ACvPN;ADwPM;EACE,8BAAA;EACA,eAAA;ACtPR;ADuPQ;EACE,iBAAA;EACA,eAAA;EACA,WAztCF;EA0tCE,WAAA;EACA,cAAA;ACrPV;ADsPU;EACE,YAAA;ACpPZ;ADsPU;EACE,+BAAA;ACpPZ;ADyPI;EACE,+BAAA;ACvPN;AD0PM;;EAEE,4BAAA;EACA,uBAAA;EACA,oBAAA;ACxPR;ADyPQ;;EACE,iBAAA;ACtPV;AD0PI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;ACxPN;ADyPM;EACE,iCAAA;EACA,iBAAA;ACvPR;ADwPQ;EAEE,iCAAA;ACvPV;AD0PM;EACE,UAAA;EACA,2BAAA;ACxPR;ADyPQ;EACE,+CAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;ACvPV;ADwPU;EACE,eAAA;EACA,4BAAA;ACtPZ;ADwPU;EACE,mBAAA;EACA,yBAAA;ACtPZ;;ADgQI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AC7PN;ADgQE;EACE,kBAAA;EACA,cAAA;AC9PJ;AD+PI;EACE,YAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AC7PN;AD+PI;EACE,eAAA;AC7PN;AD+PI;EACE,cAAA;AC7PN;ADiQI;EACE,YAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AC/PN;AD0PE;EAOE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AC9PJ;;ADiQA;EAEE,2BAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AC/PF;ADiQE;EAEE,cAAA;EAEA,aAAA;EACA,WAAA;ACjQJ;ADmQE;EACE,UAAA;ACjQJ;ADkQI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AChQN;ADkQI;EACE,UAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AChQN;ADkQI;EACE,mBA51CI;EA61CJ,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AChQN;ADiQM;EACE,8CAAA;AC/PR;;ADqQA;EACE,YAAA;AClQF;ADmQE;EACE,iBAAA;EACA,mBAAA;ACjQJ;ADoQI;EACE,8CAAA;EACA,sBAAA;AClQN;ADoQI;EACE,6CAAA;EACA,sBAAA;EACA,+CAAA;AClQN;AD0PE;EAUE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;ACjQJ;ADoQI;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,0BAAA;EACA,gBAAA;AClQN;ADmQM;EACE,qBAAA;ACjQR;ADkQQ;EACE,4BAAA;EACA,qBAAA;EACA,eAAA;AChQV;ADiQU;EACE,cA94CF;AC+oCV;ADiQU;EACE,yBAAA;AC/PZ;ADqQM;EACE,uBAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,aAAA;EACA,oBAAA;ACnQR;ADoQQ;EACE,mBAAA;AClQV;ADoQQ;EACE,+BAAA;AClQV;ADmQU;EACE,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,+BAAA;ACjQZ;ADkQY;EACE,YAAA;EACA,kBAAA;EACA,QAAA;AChQd;ADmQU;EACE,qBAAA;EACA,iBAAA;ACjQZ;ADuQU;EACE,sBAAA;EACA,kBAAA;ACrQZ;ADuQU;EACE,cA57CF;EA67CE,0BAAA;ACrQZ;;AD+QI;EACE,sBAAA;AC5QN;AD8QI;;EAEE,YAAA;EACA,kBAAA;EACA,0CAAA;AC5QN;AD6QM;;EACE,0CAAA;AC1QR;ADoQI;gCAQE,YAAA,EACA,sBAAA;EACA,gBAAA;ACxQN;AD0QI;EACE,yDAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;ACxQN;AD2QE;EACE,oCAAA;EACA,kBAAA;ACzQJ;AD0QI;EACE,uBAAA;ACxQN;ADyQM;EACE,uBAAA;ACvQR;ADwQQ;EACE,YAAA;ACtQV;ADuQU;EACE,WAp+CC;EAq+CD,eAAA;ACrQZ;AD2QE;EACE,yDAAA;EACA,4CAAA;EACA,oDAAA;ACzQJ;AD6QM;EACE,0CAAA;AC3QR;AD6QM;;EAEE,0CAAA;AC3QR;AD4QQ;;EACE,0CAAA;ACzQV;;ADgRA,gCAAA;AACA;;EAEE,wBAAA;EACA,SAAA;AC7QF;;ADgRA,YAAA;AACA;EACE,0BAAA;AC7QF;;ADsRA;EACE,gCAAA;ACnRF;ADqRI;EACE,UAAA;ACnRN;ADoRM;EACE,sBAAA;AClRR;;ADyRE;EACE,2BAAA;ACtRJ;ADwRM;EAEE,iBAAA;ACvRR;;AD6RA;EACE,aAAA;EACA,4DAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;AC1RF;AD2RE;EACE,UAAA;ACzRJ;;AD6RA;EACE,WAAA;AC1RF;AD2RE;EACE,kCAAA;EACA,oCAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;ACzRJ;AD0RI;EACE,kCAAA;ACxRN;AD0RI;EACE,WAAA;EACA,kBAAA;ACxRN;AD2RE;EACE,UAAA;EACA,sBAxkDS;EAykDT,WAAA;ACzRJ;AD0RI;EACE,aAAA;EACA,eAAA;EACA,4CAAA;ACxRN;ADyRM;EACE,YAAA;ACvRR;ADyRM;EACE,WAAA;EACA,kBAAA;ACvRR;;AD8RA;EACE;IACE,gBAAA;EC3RF;AACF;AD6RA;EACE;IACE,aAAA;EC3RF;AACF;AD8RA;EAEI;IACE,wBAAA;EC7RJ;ED+RE;IACE,aAAA;IACA,WAAA;IACA,UAAA;IACA,UAAA;EC7RJ;AACF;ADgSA;EAEI;IACE,kBAAA;EC/RJ;EDiSM;IACE,aAAA;IACA,eAAA;IACA,mBAAA;EC/RR;AACF;ADqSA;EACE;IACE,6BAAA;IACA,2BAAA;IACA,oBAAA;ECnSF;EDqSA;IACE,gCAAA;ECnSF;EDoSE;IACE,gCAAA;EClSJ;EDqSA;IACE,qBAAA;ECnSF;EDsSA;IACE,SAAA;ECpSF;EDsSA;IACE,eAAA;IACA,gBAAA;ECpSF;EDsSA;;IAEE,0BAAA;ECpSF;EDsSA;IACE,gBAAA;ECpSF;EDqSE;IACE,SAAA;IACA,UAAA;ECnSJ;EDqSE;IACE,SAAA;IACA,UAAA;ECnSJ;EDqSE;IACE,UAAA;ECnSJ;AACF;AD0SA;EAKE;IACE,cAAA;EC5SF;AACF;ACp5CA;EAEE,kBAAA;EACA,UAAA;ADq5CF;;ACl5CA;EACE,aAAA;ADq5CF;;ACl5CA;EACE,cAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;ADq5CF;;ACl5CA;EACE,iBAAA;ADq5CF;;ACl5CA;EACE,SAAA;EACA,8JAAA;EAEA,mCAAA;EACA,kCAAA;ADo5CF;;ACj5CA;EACE,+EAAA;ADo5CF;;ACj5CA;EACE,WAAA;EACA,cAAA;EAGA,uJAAA;ADk5CF;;AC54CA;EACE,kBAAA;EAEA,kBAAA;AD84CF;;AC14CA;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;AD64CF;;AC14CA;EACE,YAAA;AD64CF;;AC14CA;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;AD64CF;;AC14CA,WAAA;AACA;EACE,UAAA;EACA,YAAA;AD64CF;;AC14CA;;EAEE,sBAAA;AD64CF;;AC14CA;EACE,0BAAA;EACA,qCAAA;EACA,uJAAA;AD64CF;;ACz4CA;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;AD44CF;;ACz4CA;;;EAGE,yBAAA;AD44CF;;ACz4CA;EACE,cAAA;AD44CF;;ACz4CA;EACE,UAAA;EACA,YAAA;AD44CF;;ACz4CA;EACE,UAAA;EACA,YAAA;AD44CF;;ACz4CA;EACE,UAAA;EACA,YAAA;AD44CF;;ACz4CA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;AD44CF;;ACz4CA;EACE,eAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,iBAAA;EACA,UAAA;AD44CF;;ACz4CA;EACE,gBAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;AD44CF;;ACz4CA;EACE,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AD44CF;;AC14CA;EACE,UAAA;AD64CF;;AC14CA;EAEE,sCAAA;AD44CF;;ACz4CA;EACE,WAAA;AD44CF;;ACz4CA;EACE,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AD44CF;;ACz4CE;EACE,oCAAA;EACA,sBAAA;AD44CJ;;AE7kDA;EAEE,SAAA;EACA,2FAAA;EAEA,cAAA;EACA,kBAAA;AF8kDF;;AE3kDA;EACE,gBAAA;EAEA,yBAAA;EACA,2BAAA;EACA,4BAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;EACA,qBAAA;EACA,yBAAA;EACA,qCAAA;AF6kDF;;AE1kDA;EACE,gBAAA;EACA,eAAA;AF6kDF;;AE1kDA;EACE,eAAA;EACA,cAAA;EACA,gCAAA;EACA,eAAA;AF6kDF;;AE1kDA;;EAEE,cAAA;EACA,eAAA;EACA,uBAAA;EACA,iBAAA;AF6kDF;;AE1kDA;EACE,WAAA;EACA,kBAAA;AF6kDF;;AE1kDA;EAEE,mBAAA;AF4kDF;;AEzkDA;EACE,eAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;AF4kDF;;AEzkDA;;EAEE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2HAAA;AF4kDF;;AExkDA;;EAEE,aAAA;EACA,WAAA;AF2kDF;;AExkDA;EACE,iBAAA;EACA,mBAAA;AF2kDF;;AExkDA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EAGA,WAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AFykDF;;AEtkDA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,wCAAA;EAEA,eAAA;EACA,8BAAA;EACA,+BAAA;EACA,cAAA;EACA,yBAAA;AFwkDF;;AErkDA;EACE,cAAA;AFwkDF;;AErkDA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,wCAAA;EACA,kCAAA;EACA,2BAAA;AFwkDF;;AErkDA;EACE,iBAAA;EACA,oBAAA;EACA,wBAAA;AFwkDF;;AErkDA;;EAEE,SAAA;EACA,WAAA;EACA,QAAA;AFwkDF;;AErkDA;EACE,UAAA;AFwkDF;;AErkDA;;EAEE,eAAA;AFwkDF;;AErkDA;EACE,cAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,wCAAA;EACA,kCAAA;EACA,2BAAA;AFwkDF;;AErkDA;EACE,cAAA;AFwkDF;;AErkDA;EACE,WAAA;EACA,eAAA;EACA,qBAAA;AFwkDF;;AErkDA;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AFwkDF;;AErkDA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AFwkDF;;AErkDA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AFwkDF;;AEpkDA;EACE,wBAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4CAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;AFukDF;;AEpkDA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AFukDF;;AEpkDA;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AFukDF;;AEpkDA;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,8BAAA;EACA,2BAAA;EACA,qBAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;AFukDF;;AEpkDA;EACE,oDAAA;EACA,gBAAA;EACA,sBAAA;AFukDF;;AEpkDA;EACE,sBAAA;EACA,WAAA;AFukDF;;AEpkDA;EACE,gBAAA;EACA,oDAAA;EACA,wCAAA;AFukDF;;AEpkDA;EACE,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AFukDF;;AEnkDA;;EAEE,kBAAA;AFskDF;;AEnkDA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AFskDF;;AElkDA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,2HAAA;EAEA,iBAAA;EACA,cAAA;EACA,4CAAA;EACA,qBAAA;AFokDF;;AEjkDA;EACE,oDAAA;EACA,gBAAA;EACA,sBAAA;AFokDF;;AEjkDA;EACE,UAAA;EACA,sBAAA;AFokDF;;AEjkDA;EACE,gBAAA;EACA,oDAAA;EACA,wCAAA;AFokDF;;AEjkDA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AFokDF;;AEjkDA;EACE,mBAAA;AFokDF;;AEjkDA;EACE,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;AFokDF;;AEjkDA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;AFokDF;;AEjkDA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kCAAA;EACA,+CAAA;EACA,2BAAA;AFokDF;;AEjkDA;EACE,wBAAA;AFokDF;;AEjkDA;EACE,eAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,SAAA;EACA,kBAAA;EACA,kCAAA;EACA,SAAA;EACA,2BAAA;AFokDF;;AEjkDA;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;AFokDF;;AEjkDA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;AFokDF;;AEjkDA;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,oCAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,2BAAA;EACA,sIAAA;AFokDF;;AEhkDA;EACE,wBAAA;EACA,gBAAA;AFmkDF;;AE9jDA;EACE,yBAAA;AFikDF;;AE9jDA;EACC,wBAAA;AFikDD;;AE9jDA;EACE,0BAAA;AFikDF;;AE7jDA;EACE,cAAA;EACA,qBAAA;AFgkDF;AE/jDE;EACE,cAAA;EACA,qBAAA;AFikDJ;;AAl/DA,UAAA;AACA;EACE,WAAA;AAq/DF;;AAl/DA,UAAA;AACA;EACE,mBAAA;AAq/DF;;AAl/DA,WAAA;AAMA,oBAAA;AACA;EACE,mBAAA;AAg/DF;;AA5+DA;EACE,SAAA;EACA,UAAA;EACA,qBAAA;AA++DF;AA9+DE;EACE,iBAAA;EACA,eAAA;EACA,WAAA;EACA,iDAAA;AAg/DJ;AA/+DI;EACE,0CAAA;AAi/DN;AA/+DI;EACE,gBAAA;AAi/DN;;AA5+DA;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;AA++DF;;AA7+DA;EACE,sBAAA;EACA,aAAA;EACA,kBAAA;AAg/DF;;AAv9DA;EACE,kBAAA;EACA,YAAA;EACA,eAAA;AA09DF;AAz9DE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;AA29DJ;;AAv9DA;EACE,YAAA;EACA,6CAAA;EACA,oBAAA;AA09DF;;AAv9DA;EACE,cAAA;EACA,eAAA;EAEA,kBAAA;EACA,YAAA;AAy9DF;;AAt9DA;EACE,6BAAA;EACA,oBAAA;EACA,mBAAA;AAy9DF;;AA38DA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,iBAAA;AA88DF;;AA58DA;EACE,eAAA;EACA,YAAA;EACA,+BAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;AA+8DF;;AA78DA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;EACA,6BAAA;EACA,4BAAA;AAg9DF;;AA98DA;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;AAg9DF;;AA78DA;EACE;IACE,gBAAA;EAg9DF;AACF;AA78DA;EACE,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;AA+8DF;;AA78DA;EACE,6BAAA;EACA,qBAAA;AAg9DF;;AA78DA;EACE,UAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;EACA,qBAAA;AAg9DF;;AA78DA;EACE,UAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;AAg9DF;;AA78DA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;AAg9DF;;AA78DA;EACE,aAAA;EACA,yBAAA;AAg9DF;AA/8DE;EACE,eAAA;AAi9DJ;;AA78DA;EAEE,mBAAA;AA+8DF;AA98DE;EACE,YAAA;EACA,qBAAA;AAg9DJ;;AA38DA;EACE,2DAAA;AA88DF;;AA38DA;EAEE,yBAAA;EACA,+BAAA;EACA,qCAAA;AA68DF;;AA18DA;EAEE,mBAAA;AA48DF;;AAz8DA;EAEE,gBAAA;EACA,yBAAA;AA28DF;;AAt8DE;EACE,sBAAA;EACA,WAAA;AAy8DJ;;AAr8DA;EACE,WAAA;EACA,cAAA;AAw8DF;;AAr8DA;EACE,WAAA;EACA,kBAAA;AAw8DF;;AAn8DA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAs8DF;AAr8DE;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;AAu8DJ;AAt8DI;EACE,eAAA;AAw8DN;;AAn8DA;EACE,aAAA;EACA,8BAAA;AAs8DF;AAr8DE;EACE,UAAA;AAu8DJ;;AAn8DA;EACE,cAAA;EACA,eAAA;EACA,0BAAA;AAs8DF;;AAn8DA;EACE;IACE,qBAAA;EAs8DF;AACF;AAn8DA;EACE,wCAAA;EACA,oBAAA;AAq8DF;;AAl8DA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAq8DF;AAp8DE;EACE,sBAAA;AAs8DJ;AAp8DE;EACE,sBAAA;EACA,WAAA;EACA,gCAAA;EACA,+BAAA;AAs8DJ;;AAl8DA;EACE,WAAA;EACA,uBAAA;EACA,WAAA;AAq8DF;;AAl8DA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,qBAAA;EACA,sBAAA;AAq8DF;;AAl8DA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAq8DF;;AAl8DA;EACE,SAAA;AAq8DF;AAp8DE;EACE,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AAs8DJ;AAr8DI;EACE,iBAAA;EACA,eAAA;AAu8DN;AAp8DE;EACE,qBAAA;EACA,cAAA;AAs8DJ;;AAl8DA;EACE,aAAA;EACA,8BAAA;AAq8DF;AAp8DE;EACE,UAAA;AAs8DJ;;AAl8DA;EACE,aAAA;EACA,8BAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AAq8DF;;AAl8DA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAq8DF;;AAl8DA;EACE,uBAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;AAq8DF;;AAl8DA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;AAq8DF;;AAl8DA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;AAq8DF;;AAl8DA;EACE,WAAA;EACA,sBAAA;EACA,WAAA;AAq8DF;;AAl8DA;;EAEE,aAAA;AAq8DF;;AAl8DA;EACE,gBAAA;AAq8DF;;AAl8DA;EACE;IACE,qBAAA;IACA,iBAAA;EAq8DF;AACF;AAl8DA;EAEE,qBAAA;EACA,iBAAA;AAm8DF;;AAh8DA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;AAm8DF;;AAh8DA;EACE,WAAA;AAm8DF;;AAh8DA;EACE,uCAAA;AAm8DF;;AAj8DA;EACE,uBAAA;AAo8DF;;AAl8DA;EACE,sBAAA;AAq8DF;;AAn8DA;EACE,iBAAA;AAs8DF;;AAp8DA;EACE,aAAA;AAu8DF;;AAp8DA;EACE,aAAA;AAu8DF;AAt8DE;EACE,uBAAA;AAw8DJ;;AAr8DA;EACE,aAAA;EACA,wBAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,qBAAA;EACA,mBAAA;AAw8DF;AAt8DE;EAEE,mBAAA;AAu8DJ;;AAn8DA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAs8DF;AAr8DE;EACE,sBAAA;AAu8DJ;AAr8DE;EACE,eAAA;AAu8DJ;;AAn8DA;EACE,YAAA;EACA,YAAA;AAs8DF;AA/7DA;EACE,kBAAA;EACA,gBAAA;AAi8DF;;AA77DE;EACE,yBAAA;AAg8DJ","sourcesContent":["// Here you can add other styles\r\n\r\n@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');\r\n\r\n$primary: #eb8a0d;\r\n$white: #fff;\r\n$black: #000;\r\n$lightBlack: #333;\r\n$danger: #f86c6b;\r\n\r\n$primary: #eb8a0d;\r\n$white: #fff;\r\n$black: #000;\r\n$lightBlack: #333;\r\n$danger: #f86c6b;\r\n\r\nbody {\r\n  font-family: 'Poppins', sans-serif;\r\n}\r\n\r\n.btn {\r\n  outline: 0 !important;\r\n  box-shadow: none !important;\r\n  font-family: 'Poppins', sans-serif;\r\n  font-weight: 500;\r\n  letter-spacing: 0.5px;\r\n  transform: unset !important;\r\n}\r\n\r\na {\r\n  color: #f18f3c !important;\r\n  font-weight: 400 !important;\r\n}\r\n\r\nlabel {\r\n  font-size: 14px !important;\r\n  letter-spacing: 0.3px;\r\n  padding-left: 2px;\r\n}\r\n\r\n.ainput-group,\r\n.form-group {\r\n  margin-bottom: 15px !important;\r\n  color: gray;\r\n}\r\n\r\n.form-control {\r\n  font-size: 15px !important;\r\n  font-weight: 400;\r\n  letter-spacing: 0.3px;\r\n  padding: 6px 12px !important;\r\n  border: 1px solid #ced4da !important;\r\n\r\n  &:focus {\r\n    border-color: #f18f3c;\r\n  }\r\n}\r\n\r\n.themeBtn {\r\n  background-color: #f18f3c;\r\n  border: 1px solid #f18f3c !important;\r\n  background-image: none;\r\n  color: #fff !important;\r\n  font-size: 16px;\r\n  margin: 20px auto 10px;\r\n  width: 280px;\r\n  display: block;\r\n  height: 42px;\r\n  font-weight: 600 !important;\r\n  line-height: 42px;\r\n  padding: 0 12px;\r\n\r\n  &:hover {\r\n    background-color: #f18f3c !important;\r\n    background-image: none !important;\r\n  }\r\n}\r\n\r\n.themeBtn:focus,\r\n.themeBtn:active,\r\n.themeBtn.active,\r\n.themeBtn:active:focus,\r\n.themeBtn:active:hover,\r\n.themeBtn.active:focus,\r\n.themeBtn.active:hover {\r\n  background-color: #f18f3c !important;\r\n  background-image: none !important;\r\n}\r\n\r\n.validation-error {\r\n  color: #f16667;\r\n  font-size: 13px;\r\n  margin-top: 3px;\r\n  padding-left: 5px;\r\n}\r\n\r\n.fs-16 {\r\n  font-size: 16px !important;\r\n}\r\n\r\n.table-responsive {\r\n  overflow: unset !important;\r\n  overflow-x: auto !important;\r\n  padding-bottom: 0 !important;\r\n}\r\n\r\n.table > thead > tr > th {\r\n  font-size: 14px;\r\n}\r\n\r\n.footer {\r\n  display: flex;\r\n  // justify-content: space-between;\r\n  justify-content: center;\r\n  // align-items: center;\r\n  // padding: 10px 15px 15px 15px !important;\r\n\r\n  .copyright {\r\n    float: unset !important;\r\n    padding: 0 10px !important;\r\n  }\r\n\r\n  .nav {\r\n    float: unset !important;\r\n    align-self: flex-end;\r\n    padding-left: 10px !important;\r\n  }\r\n\r\n  &:after {\r\n    display: none !important;\r\n  }\r\n\r\n  a {\r\n    color: #697ba0 !important;\r\n  }\r\n\r\n  .lsWebsite {\r\n    color: #31c5c7 !important;\r\n  }\r\n}\r\n\r\n.main-panel > .content {\r\n  // padding: 78px 20px 15px 270px !important;\r\n  // padding: 78px 20px 15px 120px !important;\r\n  // min-height: calc(100vh - 49px) !important;\r\n}\r\n\r\n.dropdown-menu .dropdown-item {\r\n  outline: 0 !important;\r\n  color: #9a9a9a !important;\r\n}\r\n\r\n.sideMenuLogo {\r\n  width: 165px;\r\n}\r\n\r\n.main-panel[data='blue'] {\r\n  border-top: 2px solid #f18f3c;\r\n}\r\n\r\n.sidebar[data='blue'] {\r\n  background: linear-gradient(0deg, #fbd449 0%, #f4a03f 100%);\r\n}\r\n\r\n.sidebar .nav p {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n}\r\n\r\n.sidebar .nav i {\r\n  margin-right: 8px;\r\n}\r\n\r\n.modal-header {\r\n  border-bottom: 1px solid #e9ecef !important;\r\n  padding: 18px 24px 14px !important;\r\n}\r\n\r\n.modal-title {\r\n  color: white !important;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n}\r\n\r\n.modal .modal-header .close {\r\n  color: #fd5d93 !important;\r\n  padding: 10px 10px 5px !important;\r\n}\r\n\r\n.modal-body {\r\n  padding-top: 16px !important;\r\n\r\n  .form-control {\r\n    color: #fff !important;\r\n  }\r\n}\r\n\r\n.modal-footer {\r\n  padding: 14px 24px 14px !important;\r\n  justify-content: flex-end !important;\r\n\r\n  .btn {\r\n    margin-left: 12px !important;\r\n    height: 36px;\r\n    padding: 0 12px !important;\r\n    line-height: 34px !important;\r\n    border: 1px solid #f18f3c !important;\r\n    border-radius: 6px !important;\r\n  }\r\n\r\n  .modalBtnCancel {\r\n    background-color: transparent !important;\r\n    border: 1px solid #a5a5a5 !important;\r\n    background-image: none !important;\r\n    color: #a5a5a5 !important;\r\n\r\n    &:hover {\r\n      background-color: transparent !important;\r\n      background-image: none !important;\r\n      color: #a5a5a5 !important;\r\n    }\r\n  }\r\n\r\n  .modalBtnCancel:focus,\r\n  .modalBtnCancel:active,\r\n  .modalBtnCancel.active,\r\n  .modalBtnCancel:active:focus,\r\n  .modalBtnCancel:active:hover,\r\n  .modalBtnCancel.active:focus,\r\n  .modalBtnCancel.active:hover {\r\n    background-color: transparent !important;\r\n    background-image: none !important;\r\n    color: #a5a5a5 !important;\r\n  }\r\n\r\n  .modalBtnSave {\r\n    background-color: #f18f3c !important;\r\n    border: 1px solid #f18f3c !important;\r\n    background-image: none !important;\r\n    color: #fff !important;\r\n\r\n    &:hover {\r\n      background-color: #f18f3c !important;\r\n      background-image: none !important;\r\n      color: #fff !important;\r\n    }\r\n  }\r\n\r\n  .modalBtnSave:focus,\r\n  .modalBtnSave:active,\r\n  .modalBtnSave.active,\r\n  .modalBtnSave:active:focus,\r\n  .modalBtnSave:active:hover,\r\n  .modalBtnSave.active:focus,\r\n  .modalBtnSave.active:hover {\r\n    background-color: #f18f3c !important;\r\n    background-image: none !important;\r\n    color: #fff !important;\r\n  }\r\n}\r\n\r\n.login-page {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100vh;\r\n  flex-direction: column;\r\n}\r\n\r\n.companyLogo {\r\n  width: 310px;\r\n  display: block;\r\n  margin: 8px auto 35px;\r\n}\r\n\r\n.authFormWrap {\r\n  width: 100%;\r\n  max-width: 500px;\r\n  margin: 0 auto;\r\n  border: 2px solid #665f5f;\r\n  border-radius: 1rem;\r\n  // box-shadow: 0 0.46875rem 2.1875rem rgba(0, 0, 0, 0.03), 0 0.9375rem 1.40625rem rgba(0, 0, 0, 0.03),\r\n  //   0 0.25rem 0.53125rem rgba(0, 0, 0, 0.05), 0 0.125rem 0.1875rem rgba(0, 0, 0, 0.03);\r\n\r\n  .card {\r\n    margin-bottom: 0;\r\n    border-radius: 12px;\r\n    padding-top: 1.5rem;\r\n\r\n    label,\r\n    .forgotPassword {\r\n      color: #676767 !important;\r\n    }\r\n\r\n    .card-header {\r\n      padding: 22px 25px 0;\r\n\r\n      .card-title {\r\n        font-weight: 600;\r\n        color: #f18f3c;\r\n        font-size: 26px;\r\n      }\r\n    }\r\n\r\n    .card-body {\r\n      padding: 12px 25px 15px;\r\n    }\r\n  }\r\n\r\n  .form-group {\r\n    position: relative;\r\n\r\n    .form-control {\r\n      padding-left: 34px !important;\r\n      color: #fff !important;\r\n      // color: #333 !important;\r\n\r\n      &:focus {\r\n        border-color: #f18f3c !important;\r\n      }\r\n    }\r\n\r\n    .formIcon {\r\n      position: absolute;\r\n      top: 12px;\r\n      left: 12px;\r\n      font-size: 14px;\r\n      color: #b0b0b0;\r\n    }\r\n\r\n    .lockIcon {\r\n      font-size: 15px;\r\n      top: 11.5px;\r\n    }\r\n\r\n    .callIcon {\r\n      top: 12.5px;\r\n    }\r\n\r\n    .mailIcon {\r\n      top: 11.5px;\r\n    }\r\n\r\n    .showPassword {\r\n      position: absolute;\r\n      top: 12px;\r\n      right: 12px;\r\n      color: #a0a0a0;\r\n    }\r\n\r\n    .passwordField {\r\n      padding-right: 35px !important;\r\n    }\r\n  }\r\n\r\n  .themeBtn {\r\n    margin: 30px auto !important;\r\n  }\r\n\r\n  .createAccount {\r\n    color: #808080 !important;\r\n    display: block;\r\n    margin: 0 auto 10px;\r\n    width: 250px;\r\n    text-align: center;\r\n    letter-spacing: 0.3px;\r\n\r\n    span {\r\n      color: #f18f3c !important;\r\n      font-weight: 500;\r\n    }\r\n  }\r\n}\r\n\r\n.authFooter {\r\n  width: 100%;\r\n  max-width: 500px;\r\n  margin: 12px auto;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  color: #bbb;\r\n  font-size: 14px;\r\n\r\n  a {\r\n    color: #f6bb44 !important;\r\n  }\r\n}\r\n\r\n.tableFilterWrap {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding-bottom: 12px !important;\r\n\r\n  .form-control {\r\n    border-color: #676767 !important;\r\n    color: #ddd !important;\r\n\r\n    &:focus {\r\n      border-color: #f18f3c !important;\r\n    }\r\n  }\r\n}\r\n\r\n.addBtn {\r\n  background-color: #f18f3c !important;\r\n  border-color: #f18f3c !important;\r\n  color: #fff !important;\r\n  height: 38px;\r\n  line-height: 38px !important;\r\n  background-image: none !important;\r\n  padding: 0 15px !important;\r\n\r\n  &:hover,\r\n  &:focus,\r\n  &:active,\r\n  &:active:focus,\r\n  &:active:hover {\r\n    background-color: #f18f3c !important;\r\n    background-image: none !important;\r\n    color: #fff !important;\r\n  }\r\n}\r\n\r\n.addBtn.active {\r\n  background-color: #f18f3c !important;\r\n  background-image: none !important;\r\n  color: #fff !important;\r\n\r\n  &:focus,\r\n  &:hover {\r\n    background-color: #f18f3c !important;\r\n    background-image: none !important;\r\n    color: #fff !important;\r\n  }\r\n}\r\n\r\n.viewBtn {\r\n  background-color: transparent !important;\r\n  background-image: none !important;\r\n  border: 1px solid #887f77 !important;\r\n  color: #fff !important;\r\n  height: 32px;\r\n  line-height: 30px !important;\r\n  padding: 0 12px !important;\r\n\r\n  &:hover {\r\n    background-color: #737170 !important;\r\n    background-image: none !important;\r\n    color: #fff !important;\r\n  }\r\n}\r\n\r\n.viewBtn:focus,\r\n.viewBtn:active,\r\n.viewBtn.active,\r\n.viewBtn:active:focus,\r\n.viewBtn:active:hover,\r\n.viewBtn.active:focus,\r\n.viewBtn.active:hover {\r\n  background-color: #f18f3c !important;\r\n  background-image: none !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.stopBtn {\r\n  background: transparent !important;\r\n  border: 1px solid #f16667 !important;\r\n  height: 32px;\r\n  line-height: 30px !important;\r\n  padding: 0 12px !important;\r\n\r\n  &:hover {\r\n    background-color: #f16667 !important;\r\n    background-image: none !important;\r\n    color: #fff !important;\r\n  }\r\n}\r\n\r\n.stopBtn:focus,\r\n.stopBtn:active,\r\n.stopBtn.active,\r\n.stopBtn:active:focus,\r\n.stopBtn:active:hover,\r\n.stopBtn.active:focus,\r\n.stopBtn.active:hover {\r\n  background-color: #f16667 !important;\r\n  background-image: none !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.licensesList li {\r\n  background-color: transparent;\r\n  border: 0;\r\n  border-bottom: 1px solid #666;\r\n  border-radius: 0 !important;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 18px 5px;\r\n\r\n  &:first-child {\r\n    padding-top: 15px;\r\n  }\r\n\r\n  &:last-child {\r\n    border-bottom: 0;\r\n    padding-bottom: 15px;\r\n  }\r\n}\r\n\r\n.userInfo {\r\n  .card-header {\r\n    padding-bottom: 10px !important;\r\n    border-bottom: 1px solid #525252 !important;\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    letter-spacing: 0.3px;\r\n  }\r\n\r\n  .card-footer {\r\n    border-top: 1px solid #525252 !important;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 20px 15px 22px !important;\r\n\r\n    .btn {\r\n      margin: 0 0 0 20px;\r\n      flex-shrink: 0;\r\n    }\r\n  }\r\n\r\n  label {\r\n    color: #f5f5f5 !important;\r\n  }\r\n}\r\n\r\n.card-chart .card-header {\r\n  .card-category {\r\n    font-size: 15px;\r\n    letter-spacing: 0.3px;\r\n    margin-bottom: 8px !important;\r\n  }\r\n\r\n  .card-title i {\r\n    font-size: 22px !important;\r\n    color: #f18f3c;\r\n  }\r\n}\r\n\r\n.dashboardCard {\r\n  text-align: center;\r\n  cursor: pointer;\r\n  // padding: 65px 0;\r\n\r\n  i {\r\n    font-size: 36px;\r\n    color: #f18f3c;\r\n  }\r\n\r\n  h3 {\r\n    font-size: 28px;\r\n    margin: 15px 0 10px;\r\n    font-weight: 600;\r\n  }\r\n\r\n  p {\r\n    margin-bottom: 5px;\r\n    font-size: 15px;\r\n    letter-spacing: 0.3px;\r\n    font-weight: 500;\r\n  }\r\n}\r\n\r\n.custom-control-label::before,\r\n.custom-control-label::after {\r\n  border: #adb5bd solid 1px;\r\n  top: -8px !important;\r\n  width: 1rem !important;\r\n  height: 1rem !important;\r\n}\r\n\r\n.custom-control-label::after {\r\n  border: 0;\r\n}\r\n\r\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before,\r\n.custom-control-input:active ~ .custom-control-label::before {\r\n  background-color: #f18f3c;\r\n  border-color: #f18f3c;\r\n}\r\n\r\n.saveBtn {\r\n  background-color: #f18f3c !important;\r\n  border: 1px solid #f18f3c !important;\r\n  background-image: none !important;\r\n  color: #fff !important;\r\n  font-size: 16px !important;\r\n\r\n  &:hover {\r\n    background-color: #f18f3c !important;\r\n    background-image: none !important;\r\n    color: #fff !important;\r\n  }\r\n}\r\n\r\n.saveBtn:focus,\r\n.saveBtn:active,\r\n.saveBtn.active,\r\n.saveBtn:active:focus,\r\n.saveBtn:active:hover,\r\n.saveBtn.active:focus,\r\n.saveBtn.active:hover {\r\n  background-color: #f18f3c !important;\r\n  background-image: none !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.cancelBtn {\r\n  background-color: transparent !important;\r\n  border: 1px solid #a5a5a5 !important;\r\n  background-image: none !important;\r\n  color: #a5a5a5 !important;\r\n  font-size: 16px !important;\r\n\r\n  &:hover {\r\n    background-color: transparent !important;\r\n    background-image: none !important;\r\n    color: #a5a5a5 !important;\r\n  }\r\n}\r\n\r\n.cancelBtn:focus,\r\n.cancelBtn:active,\r\n.cancelBtn.active,\r\n.cancelBtn:active:focus,\r\n.cancelBtn:active:hover,\r\n.cancelBtn.active:focus,\r\n.cancelBtn.active:hover {\r\n  background-color: transparent !important;\r\n  background-image: none !important;\r\n  color: #a5a5a5 !important;\r\n}\r\n\r\n.assetImg {\r\n  height: 50px;\r\n  width: 50px;\r\n  object-fit: cover;\r\n  border: 1px solid #909090;\r\n  padding: 1px;\r\n  border-radius: 6px;\r\n  margin-right: 8px;\r\n}\r\n\r\n.newLabBtn {\r\n  position: relative;\r\n  // bottom: 30px;\r\n  // right: 20px;\r\n  left: 92%;\r\n  padding: 0 14px;\r\n  height: 40px;\r\n  line-height: 40px;\r\n  background-color: #f18f3c;\r\n  border: 1px solid #f18f3c !important;\r\n  background-image: none;\r\n  font-size: 15px;\r\n\r\n  &:hover {\r\n    background-color: #f18f3c !important;\r\n    background-image: none !important;\r\n  }\r\n}\r\n\r\n.newLabBtn:focus,\r\n.newLabBtn:active,\r\n.newLabBtn.active,\r\n.newLabBtn:active:focus,\r\n.newLabBtn:active:hover,\r\n.newLabBtn.active:focus,\r\n.newLabBtn.active:hover {\r\n  background-color: #f18f3c !important;\r\n  background-image: none !important;\r\n}\r\n\r\n.tableInModal {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.tableInModal > thead > tr > th {\r\n  color: #c0b2b2 !important;\r\n  border-bottom: 2px solid #dee2e6;\r\n  font-size: 14px;\r\n  letter-spacing: 0.3px;\r\n}\r\n\r\n.tableInModal > tbody > tr > td {\r\n  color: #676767 !important;\r\n  border-top: 1px solid #dee2e6;\r\n}\r\n\r\n.tableInModal {\r\n  .viewBtn {\r\n    color: #f18f3c !important;\r\n\r\n    &:hover {\r\n      color: #fff !important;\r\n    }\r\n  }\r\n\r\n  .viewBtn:focus,\r\n  .viewBtn:active,\r\n  .viewBtn.active,\r\n  .viewBtn:active:focus,\r\n  .viewBtn:active:hover,\r\n  .viewBtn.active:focus,\r\n  .viewBtn.active:hover {\r\n    color: #fff !important;\r\n  }\r\n\r\n  .stopBtn {\r\n    color: #f16667 !important;\r\n\r\n    &:hover {\r\n      color: #fff !important;\r\n    }\r\n  }\r\n\r\n  .stopBtn:focus,\r\n  .stopBtn:active,\r\n  .stopBtn.active,\r\n  .stopBtn:active:focus,\r\n  .stopBtn:active:hover,\r\n  .stopBtn.active:focus,\r\n  .stopBtn.active:hover {\r\n    color: #fff !important;\r\n  }\r\n}\r\n\r\n.isAdminCheck .custom-control-label::before,\r\n.isAdminCheck .custom-control-label::after {\r\n  top: 5px !important;\r\n}\r\n\r\n.isAdminWrap {\r\n  label {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .isAdminCheck .custom-control-label::before,\r\n  .isAdminCheck .custom-control-label::after {\r\n    top: 2px !important;\r\n  }\r\n}\r\n// .switch-toggle-button{\r\n// \tfont-size: 10px;\r\n// \t.react-switch-handle{\r\n\r\n// \t\t// transform: translateX(20px);\r\n// \t\t// width:40px\r\n// \t}\r\n// \t.react-switch-bg{\r\n// \t\t// padding:0 5px;\r\n// // width:40px !important;\r\n// \t}\r\n// }\r\n\r\n// Design Lab Side Menu CSS\r\n.designLabSidebar .nav {\r\n  margin-top: 50px;\r\n}\r\n\r\n#sidebarMenu {\r\n  position: absolute;\r\n  left: 0;\r\n  transform: translateX(-180px);\r\n  transition: transform 250ms ease-in-out;\r\n  z-index: 98;\r\n  overflow: auto;\r\n  scrollbar-color: rgba(103, 112, 210, 0.8) #bbb;\r\n  scrollbar-width: thin;\r\n}\r\n\r\n#sidebarMenu::-webkit-scrollbar-track {\r\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);\r\n  border-radius: 0;\r\n  background-color: #bbb;\r\n}\r\n\r\n#sidebarMenu::-webkit-scrollbar {\r\n  width: 8px;\r\n  background-color: #bbb;\r\n}\r\n\r\n#sidebarMenu::-webkit-scrollbar-thumb {\r\n  border-radius: 0;\r\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.8);\r\n  background-color: rgba(103, 112, 210, 0.8);\r\n}\r\n\r\n.sidebarMenuInner li {\r\n  list-style: none;\r\n  color: #fff;\r\n  padding: 11px 16px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  position: relative;\r\n  overflow: auto;\r\n}\r\n\r\n.designLabSidebar .sidebarMenuInner li i {\r\n  margin-right: 3px;\r\n}\r\n\r\n.designLabSidebar .sidebarMenuInner li img {\r\n  margin-right: 5px;\r\n}\r\n\r\n#sidebarMenu .sidebarMenuInner li p {\r\n  display: none;\r\n}\r\n\r\ninput[type='checkbox']:checked ~ #sidebarMenu {\r\n  transform: translateX(0px);\r\n  transition: transform 250ms ease-in-out;\r\n}\r\n\r\ninput[type='checkbox']:checked ~ #sidebarMenu .sidebarMenuInner li {\r\n  padding-right: 21px;\r\n}\r\n\r\ninput[type='checkbox']:checked ~ #sidebarMenu .sidebarMenuInner li div {\r\n  justify-content: flex-start !important;\r\n}\r\n\r\ninput[type='checkbox']:checked ~ #sidebarMenu .sidebarMenuInner li p {\r\n  display: initial;\r\n}\r\n\r\ninput[type='checkbox']:checked ~ #sidebarMenu .sidebarMenuInner li i {\r\n  font-size: 23px;\r\n  margin-right: 10px;\r\n}\r\n\r\ninput[type='checkbox']:checked ~ #sidebarMenu .sidebarMenuInner li img {\r\n  margin-right: 13px;\r\n}\r\n\r\n.designLabSidebarWrapper input[type='checkbox'] {\r\n  transition: all 0.3s;\r\n  box-sizing: border-box;\r\n  display: none;\r\n}\r\n\r\n.sidebarIconToggle {\r\n  transition: all 0.3s;\r\n  box-sizing: border-box;\r\n  cursor: pointer;\r\n  position: absolute;\r\n  z-index: 100;\r\n  height: 100%;\r\n  width: 100%;\r\n  top: 100px;\r\n  left: 23px;\r\n  height: 22px;\r\n  width: 22px;\r\n  margin-bottom: 0;\r\n}\r\n\r\ninput[type='checkbox']:checked + .sidebarIconToggle {\r\n  // left: 213px;\r\n  // margin-left: 10px;\r\n  top: 95px;\r\n}\r\n\r\n.spinner {\r\n  transition: all 0.3s;\r\n  box-sizing: border-box;\r\n  position: absolute;\r\n  height: 3px;\r\n  width: 100%;\r\n  background-color: #fff;\r\n}\r\n\r\n.horizontal {\r\n  transition: all 0.3s;\r\n  box-sizing: border-box;\r\n  position: relative;\r\n  float: left;\r\n  opacity: 1;\r\n  margin-top: 3px;\r\n}\r\n\r\n.diagonal.part-1 {\r\n  position: relative;\r\n  transition: all 0.3s;\r\n  box-sizing: border-box;\r\n  float: left;\r\n  transform: rotate(0deg);\r\n  margin-top: 1px;\r\n}\r\n\r\n.diagonal.part-2 {\r\n  transition: all 0.3s;\r\n  box-sizing: border-box;\r\n  position: relative;\r\n  float: left;\r\n  transform: rotate(0deg);\r\n  margin-top: 3px;\r\n}\r\n\r\ninput[type='checkbox']:checked ~ .sidebarIconToggle > .horizontal {\r\n  transition: all 0.3s;\r\n  box-sizing: border-box;\r\n  opacity: 0;\r\n}\r\n\r\ninput[type='checkbox']:checked ~ .sidebarIconToggle > .diagonal.part-1 {\r\n  transition: all 0.3s;\r\n  box-sizing: border-box;\r\n  transform: rotate(135deg);\r\n  margin-top: 9px;\r\n}\r\n\r\ninput[type='checkbox']:checked ~ .sidebarIconToggle > .diagonal.part-2 {\r\n  transition: all 0.3s;\r\n  box-sizing: border-box;\r\n  transform: rotate(-135deg);\r\n  margin-top: -9px;\r\n}\r\n\r\n.sideMenuTooltip .tooltip.show {\r\n  left: 125px !important;\r\n  font-size: 14px;\r\n}\r\n\r\n.main-panel > .designLabSideMenuClosedPadding {\r\n  // Change to 0\r\n  padding-left: 0px !important;\r\n  padding-right: 0 !important;\r\n}\r\n\r\n@media all and (min-width: 768px) and (max-width: 991.98px) {\r\n  .main-panel > .content {\r\n    padding-left: 15px !important;\r\n  }\r\n\r\n  // \t.navbar-expand-lg .navbar-right {\r\n  //     display: none;\r\n  //   }\r\n  //   .navbar-expand-lg .navbar-collapse {\r\n  //     display: flex !important;\r\n  //     flex-basis: auto;\r\n  //   }\r\n  //   .navbar-expand-lg .navbar-nav .nav-link {\r\n  //     padding-right: 0.5rem;\r\n  //     padding-left: 0.5rem;\r\n  //   }\r\n  //   .navbar .navbar-nav .dropdown {\r\n  //     margin: 0;\r\n  //   }\r\n  //   .navbar .caret {\r\n  //     position: absolute;\r\n  //     left: 80%;\r\n  //     top: 55%;\r\n  //     margin-left: 0;\r\n  //   }\r\n  //   .dropdown-toggle:after {\r\n  //     display: none;\r\n  //   }\r\n  //   .navbar .navbar-nav .dropdown .nav-link {\r\n  //     padding-bottom: 0.5rem;\r\n  //   }\r\n  //   .navbar-expand-lg .navbar-nav .dropdown-menu {\r\n  //     position: absolute !important;\r\n  //   }\r\n  //   .navbar .dropdown.show .dropdown-menu, .navbar .dropdown .dropdown-menu {\r\n  //     background-color: #fff;\r\n  //     box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\r\n  //     transition: all 150ms linear;\r\n  //     margin: 0.125rem 0 0;\r\n  //   }\r\n  //   .navbar-nav li {\r\n  //     padding: 0 10px !important;\r\n  //   }\r\n  //   .navbar .navbar-nav .dropdown .dropdown-menu .dropdown-item {\r\n  //     margin-top: 5px;\r\n  //   }\r\n  //   .dropdown-menu:before {\r\n  //     display: inline-block !important;\r\n  //  }\r\n}\r\n\r\n// @media (min-width: 992px) {\r\n//   .main-panel {\r\n//     width: 100%;\r\n//   }\r\n//   .nav-open .main-panel {\r\n//     right: 0;\r\n//     transform: translate3d(260px, 0, 0);\r\n//   }\r\n//   .main-panel > .content {\r\n//     padding-left: 15px !important;\r\n//   }\r\n//   .navbar-expand-lg .navbar-toggle .navbar-toggler {\r\n//     display: inline;\r\n//   }\r\n//   .navbar .navbar-toggler-bar {\r\n//     display: block;\r\n//     position: relative;\r\n//     width: 22px;\r\n//     height: 1px;\r\n//     border-radius: 1px;\r\n//     background: #FFFFFF;\r\n//   }\r\n//   .navbar .navbar-brand {\r\n//     margin-left: 20px;\r\n//     position: relative;\r\n//   }\r\n//   .bar1, .bar2, .bar3 {\r\n//     outline: 1px solid transparent;\r\n//   }\r\n//   .bar1 {\r\n//     top: 0px;\r\n//     animation: topbar-back 500ms 0s;\r\n//     animation-fill-mode: forwards;\r\n//   }\r\n//   .navbar .navbar-toggler-bar.bar2 {\r\n//     width: 17px;\r\n//     transition: width .2s linear;\r\n//   }\r\n//   .navbar .navbar-toggler-bar + .navbar-toggler-bar {\r\n//     margin-top: 7px;\r\n//   }\r\n//   .bar2 {\r\n//     opacity: 1;\r\n//   }\r\n//   .bar3 {\r\n//     bottom: 0px;\r\n//     animation: bottombar-back 500ms 0s;\r\n//     animation-fill-mode: forwards;\r\n//   }\r\n//   .sidebar {\r\n//     position: fixed;\r\n//     display: block;\r\n//     top: 0;\r\n//     height: 100%;\r\n//     width: 260px;\r\n//     right: auto;\r\n//     left: 0;\r\n//     margin: 0;\r\n//     border-radius: 0;\r\n//     z-index: 1032;\r\n//     visibility: visible;\r\n//     overflow-y: visible;\r\n//     padding: 0;\r\n//     transition: 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\r\n//     transform: translate3d(-260px, 0, 0);\r\n//   }\r\n//   .nav-open .sidebar {\r\n//     transition: 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\r\n//     transform: translate3d(0px, 0, 0);\r\n//   }\r\n// }\r\n\r\n.uploadProfile {\r\n  background: #fff !important;\r\n  border: 1px solid rgba(0, 0, 0, 0.1);\r\n  padding: 3px;\r\n  cursor: pointer;\r\n  width: 133px;\r\n  height: 133px;\r\n  border-radius: 6px;\r\n  display: block;\r\n  margin: 27px auto 15px;\r\n  position: relative;\r\n  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);\r\n\r\n  img {\r\n    height: 125px;\r\n    width: 125px;\r\n    border-radius: 4px;\r\n    object-fit: contain;\r\n  }\r\n\r\n  i {\r\n    font-size: 16px;\r\n    color: #999;\r\n    width: 32px;\r\n    height: 28px;\r\n    line-height: 26px;\r\n    position: absolute;\r\n    bottom: -13px;\r\n    left: 50.5px;\r\n    background-color: #fff;\r\n    border: 1px solid rgba(0, 0, 0, 0.1);\r\n    text-align: center;\r\n    border-radius: 6px;\r\n  }\r\n}\r\n.checkBox {\r\n  width: 20px;\r\n  height: 20px;\r\n  margin-right: 15px;\r\n  cursor: pointer;\r\n}\r\n\r\ninput[type='checkbox']:not(:checked) ~ #sidebarMenu .zoom-slider-wrap {\r\n  display: none;\r\n}\r\n\r\n.truncate {\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 1;\r\n  -webkit-box-orient: vertical;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  width: 150px;\r\n}\r\n\r\n.modal-content {\r\n  position: relative;\r\n}\r\n\r\n.resizable-container {\r\n  width: 100% !important;\r\n}\r\n\r\n.rawfields {\r\n  height: 500px !important;\r\n  max-height: inherit !important;\r\n}\r\n\r\n.jtk-draw-skeleton {\r\n  outline: none;\r\n}\r\n\r\n.jtk-draw-handle {\r\n  background-color: #1e1e2f4d;\r\n  width: 5px !important;\r\n  height: 5px !important;\r\n}\r\n\r\n.jtk-surface-selected-element {\r\n  border: 1px dotted #1e1e2f4d !important;\r\n}\r\n\r\n// .wrapper {\r\n// \toverflow: hidden;\r\n// }\r\n.cardGrid {\r\n  width: 100%;\r\n  flex: 0 0 25%;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.labCard {\r\n  height: 100%;\r\n  .card-header {\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    border-bottom: 1px dashed #333;\r\n    padding-bottom: 15px;\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n  }\r\n  .card-body {\r\n    padding-bottom: 0;\r\n    .list-group {\r\n      .list-group-item {\r\n        background: transparent;\r\n        border: none;\r\n        border-bottom: 1px dashed $lightBlack;\r\n        padding-top: 10px;\r\n        padding-bottom: 10px;\r\n        padding-left: 0;\r\n        display: flex;\r\n        &:last-child {\r\n          border-bottom: none;\r\n        }\r\n        span {\r\n          color: rgba($color: #fff, $alpha: 0.6);\r\n          &:first-child {\r\n            display: inline-block;\r\n            width: 110px;\r\n            position: relative;\r\n            text-transform: capitalize;\r\n            color: rgba($color: #fff, $alpha: 0.9);\r\n            &::after {\r\n              content: ':';\r\n              position: absolute;\r\n              right: 0;\r\n            }\r\n          }\r\n        }\r\n      }\r\n      &.teamCount {\r\n        li {\r\n          span {\r\n            width: auto !important;\r\n            margin-right: 10px;\r\n          }\r\n          button {\r\n            color: $primary;\r\n            text-decoration: underline;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .dropdown {\r\n    > button {\r\n      padding: 0 8px;\r\n      background: transparent !important;\r\n      font-size: 18px;\r\n      &:focus,\r\n      &:active:focus {\r\n        background: transparent !important;\r\n      }\r\n    }\r\n  }\r\n\r\n  .viewBtn {\r\n    padding: 0 18px !important;\r\n  }\r\n  .centerButton {\r\n    .viewBtn {\r\n      padding: 0 24px !important;\r\n      margin: 0 10px;\r\n    }\r\n  }\r\n  &.uploadCard {\r\n    .card-img-top {\r\n      height: 200px;\r\n      object-fit: cover;\r\n    }\r\n    .badge {\r\n      position: absolute;\r\n      left: 10px;\r\n      top: 10px;\r\n      padding: 10px 20px;\r\n      font-size: 16px;\r\n      background-color: $primary;\r\n      color: $white;\r\n    }\r\n    .uploadInfo {\r\n      padding: 0;\r\n      list-style: none;\r\n      li {\r\n        border-bottom: 1px dashed #333;\r\n        padding: 10px 0;\r\n        span {\r\n          margin-right: 5px;\r\n          font-size: 14px;\r\n          color: $white;\r\n          width: auto;\r\n          display: block;\r\n          &:first-child {\r\n            width: 120px;\r\n          }\r\n          &:last-child {\r\n            color: rgba($color: $white, $alpha: 0.7);\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .para {\r\n      color: rgba($color: $white, $alpha: 0.6);\r\n    }\r\n    .actionButton {\r\n      .viewBtn,\r\n      .stopBtn {\r\n        padding: 0px 24px !important;\r\n        height: 36px !important;\r\n        margin: 10px 8px 0px;\r\n        i {\r\n          margin-right: 5px;\r\n        }\r\n      }\r\n    }\r\n    .actionDrop {\r\n      position: absolute;\r\n      right: 10px;\r\n      top: 10px;\r\n      > button {\r\n        background-color: $lightBlack !important;\r\n        padding: 4px 16px;\r\n        &:focus,\r\n        &:hover {\r\n          background-color: $lightBlack !important;\r\n        }\r\n      }\r\n      .dropdown-menu {\r\n        padding: 0;\r\n        min-width: 100px !important;\r\n        .dropdown-item {\r\n          border-bottom: 1px dashed rgba($color: $lightBlack, $alpha: 0.1);\r\n          color: $lightBlack !important;\r\n          font-size: 14px;\r\n          padding: 6px 20px;\r\n          i {\r\n            font-size: 18px;\r\n            margin-right: 6px !important;\r\n          }\r\n          &:last-child {\r\n            border-bottom: none;\r\n            color: #f16667 !important;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.appInfo {\r\n  .card-header {\r\n    span {\r\n      font-size: 18px;\r\n      font-weight: 600;\r\n      display: block;\r\n    }\r\n  }\r\n  .license_code {\r\n    text-align: center;\r\n    margin: 30px 0;\r\n    img {\r\n      width: 120px;\r\n      margin: auto;\r\n      display: block;\r\n      margin-bottom: 30px;\r\n    }\r\n    h2 {\r\n      font-size: 18px;\r\n    }\r\n    span {\r\n      color: #f16667;\r\n    }\r\n  }\r\n  .uptodate {\r\n    img {\r\n      width: 100px;\r\n      margin: auto;\r\n      display: block;\r\n      margin-bottom: 30px;\r\n    }\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    text-align: center;\r\n    margin: 30px 0;\r\n  }\r\n}\r\n.cardLibrary {\r\n  // background-color: #202020 !important;\r\n  background: none !important;\r\n  padding: 20px 10px;\r\n  border-radius: 20px;\r\n  height: 100%;\r\n\r\n  .card-img-top {\r\n    // object-fit: cover;\r\n    display: block;\r\n    // margin: auto;\r\n    height: 120px;\r\n    width: auto;\r\n  }\r\n  .card-body {\r\n    padding: 0;\r\n    .card-title {\r\n      text-align: center;\r\n      font-size: 16px;\r\n      font-weight: 500;\r\n      letter-spacing: 0.1px;\r\n      margin: 25px 0;\r\n    }\r\n    .badge {\r\n      width: 80%;\r\n      display: block;\r\n      margin: auto !important;\r\n      font-size: 16px;\r\n      padding: 12px 0;\r\n      border-radius: 20px;\r\n      font-weight: 600;\r\n    }\r\n    .btnInstall {\r\n      background: $primary;\r\n      margin: 0;\r\n      border-radius: 50px;\r\n      margin: auto !important;\r\n      width: 150px;\r\n      &:hover {\r\n        background: rgba($color: $primary, $alpha: 0.8) !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.userCard {\r\n  height: 100%;\r\n  .card-img-top {\r\n    max-height: 240px;\r\n    object-fit: contain;\r\n  }\r\n  .badge {\r\n    &.badge-success {\r\n      background: rgba(91, 209, 159, 0.6) !important;\r\n      color: $white !important;\r\n    }\r\n    &.badge-danger {\r\n      background: rgba(255, 66, 65, 0.6) !important;\r\n      color: $white !important;\r\n      border-color: rgba(255, 66, 65, 0.6) !important;\r\n    }\r\n    position: absolute;\r\n    right: 15px;\r\n    top: 15px;\r\n    font-size: 14px;\r\n    font-weight: 600 !important;\r\n    padding: 4px 8px;\r\n  }\r\n  .card-body {\r\n    .card-title {\r\n      display: flex;\r\n      justify-content: center;\r\n      font-size: 18px;\r\n      margin-bottom: 10px;\r\n      text-transform: capitalize;\r\n      font-weight: 600;\r\n      span {\r\n        display: inline-block;\r\n        i {\r\n          margin-left: 15px !important;\r\n          display: inline-block;\r\n          cursor: pointer;\r\n          &.edit {\r\n            color: $primary;\r\n          }\r\n          &.delete {\r\n            color: $danger !important;\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .list-group {\r\n      .list-group-item {\r\n        background: transparent;\r\n        border: none;\r\n        border-bottom: 1px dashed $lightBlack;\r\n        padding-top: 10px;\r\n        display: flex;\r\n        padding-bottom: 10px;\r\n        &:last-child {\r\n          border-bottom: none;\r\n        }\r\n        span {\r\n          color: rgba($color: #fff, $alpha: 0.6);\r\n          &:first-child {\r\n            display: inline-block;\r\n            width: 105px;\r\n            position: relative;\r\n            text-transform: capitalize;\r\n            color: rgba($color: #fff, $alpha: 0.9);\r\n            &::after {\r\n              content: ':';\r\n              position: absolute;\r\n              right: 0;\r\n            }\r\n          }\r\n          &:last-child {\r\n            word-break: break-all;\r\n            text-align: right;\r\n          }\r\n        }\r\n      }\r\n      &.teamCount {\r\n        li {\r\n          span {\r\n            width: auto !important;\r\n            margin-right: 10px;\r\n          }\r\n          button {\r\n            color: $primary;\r\n            text-decoration: underline;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.innerForm {\r\n  .form-group {\r\n    label {\r\n      color: $white !important;\r\n    }\r\n    input:not([type='checkbox']),\r\n    select {\r\n      height: 50px;\r\n      border-radius: 6px;\r\n      color: rgba($color: $white, $alpha: 0.5) !important;\r\n      &::placeholder {\r\n        color: rgba($color: $white, $alpha: 0.5) !important;\r\n      }\r\n      -moz-appearance: none; /* Firefox */\r\n      -webkit-appearance: none; /* Safari and Chrome */\r\n      appearance: none;\r\n    }\r\n    select {\r\n      background-image: url(\"data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>\");\r\n      background-repeat: no-repeat;\r\n      background-position-x: 98%;\r\n      background-position-y: 12px;\r\n    }\r\n  }\r\n  .input-group {\r\n    border: 1px solid #ced4da !important;\r\n    border-radius: 6px;\r\n    input {\r\n      border: none !important;\r\n      ~ .input-group-append {\r\n        border: none !important;\r\n        .input-group-text {\r\n          border: none;\r\n          i {\r\n            color: $lightBlack;\r\n            font-size: 20px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  input:-webkit-autofill {\r\n    -webkit-text-fill-color: rgba($color: $lightBlack, $alpha: 0.6) !important;\r\n    box-shadow: 0 0 0 30px #fff inset !important;\r\n    -webkit-box-shadow: 0 0 0 30px #fff inset !important;\r\n  }\r\n  &.innerCard {\r\n    .form-group {\r\n      label {\r\n        color: rgba($color: #fff, $alpha: 0.8) !important;\r\n      }\r\n      input,\r\n      select {\r\n        color: rgba($color: #fff, $alpha: 0.5) !important;\r\n        &::placeholder {\r\n          color: rgba($color: #fff, $alpha: 0.5) !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n/* Chrome, Safari, Edge, Opera */\r\ninput::-webkit-outer-spin-button,\r\ninput::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n/* Firefox */\r\ninput[type='number'] {\r\n  -moz-appearance: textfield;\r\n}\r\n.sidebar,\r\n.off-canvas-sidebar {\r\n  // margin-top: 90px !important;\r\n}\r\n// .main-panel > .content {\r\n// \tpadding-top: 90px !important;\r\n// }\r\n.userDetail {\r\n  list-style-type: none !important;\r\n  ul.dropdown-menu {\r\n    li {\r\n      padding: 0;\r\n      button {\r\n        color: $lightBlack !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.checkBox_inline {\r\n  .form-group {\r\n    margin-bottom: 0 !important;\r\n    .custom-control-label {\r\n      &::before,\r\n      &::after {\r\n        top: 0 !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.LibraryColumn {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\r\n  grid-gap: 20px;\r\n  margin: 0;\r\n  margin-bottom: 30px;\r\n  .col {\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n.imageDropdown {\r\n  width: 100%;\r\n  .dropdown-toggle {\r\n    background: transparent !important;\r\n    border: 1px solid #ced4da !important;\r\n    padding: 10px;\r\n    width: 100%;\r\n    text-align: left;\r\n    font-weight: 400;\r\n    &:focus {\r\n      background: transparent !important;\r\n    }\r\n    img {\r\n      width: 24px;\r\n      margin-right: 10px;\r\n    }\r\n  }\r\n  .dropdown-menu {\r\n    padding: 0;\r\n    background-color: $lightBlack;\r\n    width: 100%;\r\n    .dropdown-item {\r\n      padding: 10px;\r\n      cursor: pointer;\r\n      border-bottom: 1px dashed rgba($color: $black, $alpha: 0.4);\r\n      &:last-child {\r\n        border: none;\r\n      }\r\n      img {\r\n        width: 24px;\r\n        margin-right: 10px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// responsive\r\n@media screen and (max-width: 1600px) {\r\n  .cardGrid {\r\n    flex: 0 0 33.33%;\r\n  }\r\n}\r\n@media screen and (max-width: 1200px) {\r\n  .cardGrid {\r\n    flex: 0 0 50%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1024px) {\r\n  .login-page {\r\n    .loginRight {\r\n      display: none !important;\r\n    }\r\n    .logoIcon {\r\n      opacity: 0.05;\r\n      right: -18%;\r\n      top: -40px;\r\n      width: 50%;\r\n    }\r\n  }\r\n}\r\n@media screen and (max-width: 1366px) {\r\n  .tableFilterWrap {\r\n    .nav-tabs {\r\n      overflow-y: scroll;\r\n      li {\r\n        a {\r\n          padding: 10px;\r\n          font-size: 14px;\r\n          white-space: nowrap;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .userDetail ul.dropdown-menu {\r\n    position: absolute !important;\r\n    background: #fff !important;\r\n    margin: 0 !important;\r\n  }\r\n  .userDetail {\r\n    list-style-type: none !important;\r\n    &::marker {\r\n      list-style-type: none !important;\r\n    }\r\n  }\r\n  .userDetail ul.dropdown-menu li.nav-link {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .userDetail ul.dropdown-menu li.nav-link button {\r\n    margin: 0;\r\n  }\r\n  .main-panel > .navbar {\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n  }\r\n  .sidebar,\r\n  .off-canvas-sidebar {\r\n    margin-top: 0px !important;\r\n  }\r\n  .designLabSidebarWrapper {\r\n    z-index: 9999999;\r\n    .sidebarIconToggle {\r\n      top: 24px;\r\n      left: 30px;\r\n    }\r\n    input[type='checkbox']:checked + .sidebarIconToggle {\r\n      top: 24px;\r\n      left: 30px;\r\n    }\r\n    ~ .main-panel {\r\n      z-index: 1;\r\n    }\r\n  }\r\n  .content.designLabSideMenuClosedPadding {\r\n    // padding-left: 85px !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .main-panel > .content {\r\n    // padding-left: 20px !important;\r\n  }\r\n\r\n  .cardGrid {\r\n    flex: 1 1 100%;\r\n  }\r\n}\r\n","// Import Font Awesome Icons Set\r\n@import '~font-awesome/css/font-awesome.min.css';\r\n// Import Simple Line Icons Set\r\n@import '~simple-line-icons/css/simple-line-icons.css';\r\n// Import Main styles for this application\r\n@import './scss/style.scss';\r\n// copied from web app\r\n@import './scss/web-app.scss';\r\n\r\n// Scroll css start\r\n/* width */\r\n::-webkit-scrollbar {\r\n  width: 10px;\r\n}\r\n\r\n/* Track */\r\n::-webkit-scrollbar-track {\r\n  border-radius: 10px;\r\n}\r\n\r\n/* Handle */\r\n::-webkit-scrollbar-thumb {\r\n  // background: #d0d0d0;\r\n  // border-radius: 10px;\r\n}\r\n\r\n/* Handle on hover */\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: #8c8c8c;\r\n}\r\n// Scroll css end\r\n\r\n.custom-context-menu {\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style-type: none;\r\n  li {\r\n    padding: 7px 10px;\r\n    cursor: pointer;\r\n    color: #222;\r\n    border-bottom: 1px solid #cccc;\r\n    &:hover {\r\n      background-color: #cccc;\r\n    }\r\n    &:last-child {\r\n      border-bottom: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.lab-name {\r\n  position: absolute;\r\n  left: 40%;\r\n  font-size: 24px;\r\n  color: #f6bb44;\r\n}\r\n.editor-wrapper {\r\n  background-color: #fff;\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n}\r\n\r\nsvg {\r\n  // z-index: 99;\r\n}\r\n\r\nrect {\r\n  // opacity: 0.5;\r\n}\r\n\r\n// .svg_select_boundingRect {\r\n//   pointer-events: none !important;\r\n//   /* important added */\r\n// }\r\n\r\n#myDrawing {\r\n  svg {\r\n    // pointer-events: none !important;\r\n  }\r\n  circle {\r\n    // opacity: 0.5;\r\n  }\r\n}\r\n\r\n.import-btn {\r\n  position: relative;\r\n  height: 38px;\r\n  cursor: pointer;\r\n  .file-input {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    opacity: 0;\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n.disable-action {\r\n  opacity: 0.5;\r\n  background: #dddddd78;\r\n  pointer-events: none;\r\n}\r\n\r\n.lab-edit-icon {\r\n  color: #f5ab41;\r\n  cursor: pointer;\r\n  // margin-left: 10px;\r\n  margin-right: 1rem;\r\n  float: right;\r\n}\r\n\r\n.custom-select-section {\r\n  border-bottom: 1px solid #ddd;\r\n  padding-bottom: 10px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n// .del-label{\r\n//   display: none;\r\n// }\r\n\r\n// .connecttion{\r\n//     // z-index: 999999;\r\n//     &:hover + .del-label{\r\n//         display: block;\r\n//       }\r\n// }\r\n\r\n.flexible-modal {\r\n  position: absolute;\r\n  z-index: 1;\r\n  border: 1px solid #ccc;\r\n  background: white;\r\n}\r\n.flexible-modal-mask {\r\n  position: fixed;\r\n  height: 100%;\r\n  background: rgba(55, 55, 55, 0%);\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  pointer-events: none;\r\n}\r\n.flexible-modal-resizer {\r\n  position: absolute;\r\n  right: 0;\r\n  bottom: 0;\r\n  cursor: se-resize;\r\n  margin: 5px;\r\n  border-bottom: solid 2px #333;\r\n  border-right: solid 2px #333;\r\n}\r\n.flexible-modal-drag-area {\r\n  // background: #fff;\r\n  color: #222;\r\n  height: 50px;\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n  cursor: move;\r\n}\r\n\r\n@media screen and (min-width: 991px) {\r\n  .navbar .navbar-brand {\r\n    margin-top: 15px;\r\n  }\r\n}\r\n\r\n.page-link {\r\n  position: relative;\r\n  display: block;\r\n  padding: 0.5rem 0.75rem;\r\n  margin-left: -1px;\r\n  line-height: 1.25;\r\n  color: #ffff;\r\n  background-color: #171717;\r\n  border: 1px solid #f18f3c;\r\n}\r\n.page-item.disabled .page-link {\r\n  background-color: transparent;\r\n  border-color: #f18f3c;\r\n}\r\n\r\n.page-link:hover {\r\n  z-index: 2;\r\n  color: #27293d;\r\n  text-decoration: none;\r\n  background-color: #f18f3c;\r\n  border-color: #f18f3c;\r\n}\r\n\r\n.page-item.active .page-link {\r\n  z-index: 1;\r\n  color: #ffffff;\r\n  background-color: #f18f3c;\r\n  border-color: #f18f3c;\r\n}\r\n\r\n.zoom-slider-wrap {\r\n  position: absolute;\r\n  left: 25px;\r\n  bottom: 15px;\r\n  display: flex;\r\n}\r\n\r\n.adv-check-wrap {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  .checkbox-wrap {\r\n    margin-top: 2px;\r\n  }\r\n}\r\n\r\n.group-by-wrap {\r\n  // text-align: right;\r\n  margin-bottom: 20px;\r\n  select {\r\n    width: 100px;\r\n    display: inline-block;\r\n  }\r\n}\r\n\r\n// theme change\r\n.sidebar[data='blue'] {\r\n  background: linear-gradient(0deg, #151515 0%, #151515 100%);\r\n}\r\n\r\nbody {\r\n  // background: linear-gradient(0deg, #232323 0%, #2a2a2a 100%);\r\n  background-color: #141414;\r\n  color: rgba(255, 255, 255, 0.8);\r\n  font-family: 'Roboto Mono', monospace;\r\n}\r\n\r\n.main-panel {\r\n  // background: linear-gradient(#232323, #2a2a2a);\r\n  background: #141414;\r\n}\r\n\r\n.card {\r\n  // background: #171717;\r\n  background: none;\r\n  border: 1px solid #222322;\r\n}\r\n\r\n.modal {\r\n  // color: #222;\r\n  .page-link {\r\n    background-color: #fff;\r\n    color: #222;\r\n  }\r\n}\r\n\r\n.dashboard-docker-icon {\r\n  width: 37px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.lab-menu-img {\r\n  width: 30px;\r\n  margin-right: 12px;\r\n}\r\n\r\n// conection\r\n\r\n.connection-info-wrap {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 15px;\r\n  .info {\r\n    text-align: center;\r\n    width: 30%;\r\n    position: relative;\r\n    i {\r\n      font-size: 40px;\r\n    }\r\n  }\r\n}\r\n\r\n.port-form-wrap {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  .form-group {\r\n    width: 45%;\r\n  }\r\n}\r\n\r\n.delete-link-icon {\r\n  color: #e68539;\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n}\r\n\r\n@keyframes beat {\r\n  to {\r\n    transform: scale(1.1);\r\n  }\r\n}\r\n\r\n.processing-node-wrap {\r\n  animation: beat 0.25s infinite alternate;\r\n  pointer-events: none;\r\n}\r\n\r\n.custom-guacamole-modal {\r\n  z-index: 9999;\r\n  border-radius: 20px;\r\n  box-shadow: 10px 5px 30px #222;\r\n  .body {\r\n    background-color: #fff;\r\n  }\r\n  .modal-footer {\r\n    background-color: #fff;\r\n    color: #222;\r\n    border-bottom-right-radius: 20px;\r\n    border-bottom-left-radius: 20px;\r\n  }\r\n}\r\n\r\n.action-menu-img {\r\n  width: 22px;\r\n  margin: 0px -3px 0 -3px;\r\n  float: left;\r\n}\r\n\r\n.color-preview {\r\n  display: inline-block;\r\n  width: 12px;\r\n  height: 12px;\r\n  border: 1px dashed rgb(34, 34, 34);\r\n  margin: -1px 0 0 10px;\r\n  vertical-align: middle;\r\n}\r\n\r\n.change-pwd-eye-icon {\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 36px;\r\n  cursor: pointer;\r\n  color: #f18f3c;\r\n  font-size: 16px;\r\n}\r\n\r\n.profile-item-wrap {\r\n  margin: 0;\r\n  .profile-item {\r\n    border: 1px solid #ced4da;\r\n    text-align: center;\r\n    margin: 0 10px 10px 0;\r\n    width: 75px;\r\n    height: 75px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    display: flex;\r\n    border-radius: 4px;\r\n    flex-direction: column;\r\n    padding: 5px;\r\n    transition: all 0.2s;\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n    position: relative;\r\n    .profile-name {\r\n      line-height: 16px;\r\n      margin-top: 8px;\r\n    }\r\n  }\r\n  .active-profile-item {\r\n    border-color: #f18f3c;\r\n    color: #f18f3c;\r\n  }\r\n}\r\n\r\n.emulation-fields {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  .form-group {\r\n    width: 47%;\r\n  }\r\n}\r\n\r\n.emulation-item-wrap {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  border: 1px solid #f18f3c;\r\n  border-radius: 4px;\r\n  padding: 9px;\r\n}\r\n\r\n.emulation-items {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.emulation-del-icon {\r\n  justify-content: center;\r\n  color: red;\r\n  cursor: pointer;\r\n  font-size: 18px;\r\n}\r\n\r\n.remove-profile-icon {\r\n  position: absolute;\r\n  top: -6px;\r\n  right: -6px;\r\n  color: red;\r\n  font-size: 15px;\r\n  background: #fff;\r\n}\r\n\r\n.custom-tag {\r\n  position: absolute;\r\n  width: 18px;\r\n  left: 0px;\r\n  top: -3px;\r\n}\r\n\r\n.side-menu-img {\r\n  width: 25px;\r\n  margin: 4px 12px 0 6px;\r\n  float: left;\r\n}\r\n\r\n.flexible-modal-drag-area-right,\r\n.flexible-modal-drag-area-left {\r\n  display: none;\r\n}\r\n\r\nbody.no-scroll {\r\n  overflow: hidden;\r\n}\r\n\r\n@keyframes blink {\r\n  50% {\r\n    border-color: #f18f3c;\r\n    border-width: 4px;\r\n  }\r\n}\r\n\r\n.active-guacamole-modal {\r\n  // animation: blink .5s step-end infinite alternate;\r\n  border-color: #f18f3c;\r\n  border-width: 4px;\r\n}\r\n\r\n.adjust-minimize-icon {\r\n  position: absolute;\r\n  right: 45px;\r\n  top: 20px;\r\n  font-size: 15px;\r\n  color: #000;\r\n  cursor: pointer;\r\n  z-index: 9;\r\n}\r\n\r\n.otp-text {\r\n  color: #222;\r\n}\r\n\r\n.full-page-modal {\r\n  max-width: calc(100vw - 10%) !important;\r\n}\r\n.full-page-modal .modal-body {\r\n  padding: 2px !important;\r\n}\r\n.drawing-board-container {\r\n  width: 100% !important;\r\n}\r\n.drawing-board-toolbar-iconLabel {\r\n  line-height: 13px;\r\n}\r\n.drawing-board-toolbar-icon:last-child {\r\n  display: none;\r\n}\r\n\r\n.drawing-item-wrap {\r\n  height: 100vh;\r\n  h4 {\r\n    color: white !important;\r\n  }\r\n}\r\n.drawing-item {\r\n  padding: 10px;\r\n  border: 1px solid orange;\r\n  margin: 10px;\r\n  border-radius: 10px;\r\n  width: 23%;\r\n  display: inline-block;\r\n  vertical-align: top;\r\n  // height: 260px;\r\n  img {\r\n    // height: 235px;\r\n    object-fit: contain;\r\n  }\r\n}\r\n\r\n.drawing-info {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-top: 10px;\r\n  h4 {\r\n    color: #222 !important;\r\n  }\r\n  i {\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n.drawing-name {\r\n  width: 250px;\r\n  margin: 10px;\r\n  // color: #222;\r\n  &:focus {\r\n    // color: #222 !important;\r\n  }\r\n}\r\n\r\n.no-drawings {\r\n  text-align: center;\r\n  padding-top: 20%;\r\n}\r\n\r\n.footer {\r\n  .orange-text {\r\n    color: #f6bb44 !important;\r\n  }\r\n}\r\n",".App {\r\n  // height: 100vh;\r\n}\r\n.custom-node {\r\n  // border: 1px solid #222;\r\n  position: relative;\r\n  z-index: 9;\r\n}\r\n\r\n.connect {\r\n  display: none;\r\n}\r\n\r\n.custom-node:hover .connect {\r\n  display: block;\r\n  background-image: url('../assets/img/lan.png');\r\n  background-size: contain;\r\n  background-repeat: no-repeat;\r\n  width: 30px;\r\n  height: 30px;\r\n  background-color: transparent;\r\n}\r\n\r\n.select-mode {\r\n  cursor: crosshair;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',\r\n    'Droid Sans', 'Helvetica Neue', sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\r\n}\r\n\r\n.jtk-surface {\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  // background-size: 20px 20px;\r\n  // background-color: rgba(0, 0, 0, 0.08);\r\n  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.2) 1px, transparent 0px),\r\n    linear-gradient(rgba(255, 255, 255, 0.2) 1px, transparent 0px);\r\n  // background-image: url('../assets/img/header.jpg');\r\n  // background-repeat: no-repeat;\r\n}\r\n\r\n.jtk-node {\r\n  /* width: 100px; */\r\n  // color: white;\r\n  text-align: center;\r\n  // padding: 7px;\r\n}\r\n\r\n.jtk-overlay {\r\n  background-color: white;\r\n  padding: 7px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.jtk-node button {\r\n  margin: 10px;\r\n}\r\n\r\n.colorButton {\r\n  position: absolute;\r\n  z-index: 1000;\r\n  top: 50px;\r\n  right: 101px;\r\n  background-color: blue;\r\n  padding: 12px;\r\n  outline: 0;\r\n  border: none;\r\n  color: white;\r\n  border-radius: 7px;\r\n  box-shadow: 2px 2px 10px grey;\r\n}\r\n\r\n/* custom */\r\n.editBtn {\r\n  top: 120px;\r\n  right: 101px;\r\n}\r\n\r\n.jtk-group.jtk-drag-hover,\r\n.jtk-node.jtk-drag-hover {\r\n  outline: 2px solid red;\r\n}\r\n\r\n#drawing {\r\n  background-size: 20px 20px;\r\n  background-color: rgba(0, 0, 0, 0.08);\r\n  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.2) 1px, transparent 0px),\r\n    linear-gradient(rgba(255, 255, 255, 0.2) 1px, transparent 0px);\r\n}\r\n\r\n.zoom-range {\r\n  position: absolute;\r\n  z-index: 1000;\r\n  top: 180px;\r\n  right: 101px;\r\n}\r\n\r\n.jtk-surface.jtk-drag-drop-active,\r\n.jtk-node.jtk-drag-drop-active,\r\n.jtk-group.jtk-drag-drop-active {\r\n  outline: 4px solid purple;\r\n}\r\n\r\nsvg.jtk-drag-drop-active path {\r\n  stroke: purple;\r\n}\r\n\r\n.deleteBtn {\r\n  top: 240px;\r\n  right: 101px;\r\n}\r\n\r\n.selectModeBtn {\r\n  top: 310px;\r\n  right: 101px;\r\n}\r\n\r\n.updateLinkBtn {\r\n  top: 370px;\r\n  right: 101px;\r\n}\r\n\r\n.adjust-minimize-icon {\r\n  position: absolute;\r\n  right: 45px;\r\n  top: 20px;\r\n  font-size: 15px;\r\n  color: #000;\r\n}\r\n\r\n.custom-modal {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 25%;\r\n  z-index: 1050;\r\n  background: white;\r\n  width: 50%;\r\n}\r\n\r\n.minimised-modal-list {\r\n  background: #fff;\r\n  position: fixed;\r\n  bottom: 0;\r\n  width: 100%;\r\n  padding: 10px;\r\n  display: flex;\r\n}\r\n\r\n.minimised-modal-item {\r\n  align-items: flex-start;\r\n  margin-right: 10px;\r\n  padding: 5px;\r\n  border: 1px solid #222;\r\n  border-radius: 4px;\r\n}\r\n.jtk-connector {\r\n  z-index: 9;\r\n}\r\n\r\n.jtk-hover {\r\n  // filter: drop-shadow(8px 12px 7px rgba(255,165,0,1))\r\n  /* box-shadow: 2px 2px 19px #e0e0e0; */\r\n}\r\n\r\n.jtk-draw-skeleton {\r\n  z-index: 10;\r\n}\r\n\r\n.controls i {\r\n  background-color: rgba(38, 38, 38, 0.7);\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  margin-right: 5px;\r\n  border: 1px solid white;\r\n  font-size: 18px;\r\n  font-style: normal;\r\n  width: 30px;\r\n  height: 30px;\r\n  text-align: center;\r\n  padding: 5px 5px;\r\n}\r\n.controls {\r\n  .selected-mode {\r\n    background-color: #f18f3c !important;\r\n    color: #fff !important;\r\n  }\r\n}\r\n",".card-Feed {\r\n  // padding: 4px 8px;\r\n  border: 0;\r\n  box-shadow: rgba(2, 8, 20, 0.1) 0px 0.175em 0.5em,\r\n    rgba(2, 8, 20, 0.08) 0px 0.085em 0.175em;\r\n  margin: 15px 0;\r\n  border-radius: 8px;\r\n}\r\n\r\n.card-Feed .card-header {\r\n  background: #fff;\r\n  // padding: 6px 0 8px 0;\r\n  padding: 10px 8px 8px 8px;\r\n  border-top-left-radius: 8px;\r\n  border-top-right-radius: 8px;\r\n  color: #3c4b64;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  border-color: rgba(0, 0, 0, 0.1);\r\n  letter-spacing: 0.3px;\r\n  background-color: #f0f3f5;\r\n  background: rgba(145, 117, 224, 0.15);\r\n}\r\n\r\n.card-Feed .card-header h4 {\r\n  margin-bottom: 0;\r\n  font-size: 17px;\r\n}\r\n\r\n.card-Feed .card-header .profileID {\r\n  font-size: 15px;\r\n  color: #1F1F1F;\r\n  text-decoration: none !important;\r\n  cursor: pointer;\r\n}\r\n\r\n.postTime-Feed,\r\n.lastSeen-Feed {\r\n  color: #b1b1b1;\r\n  font-size: 14px;\r\n  letter-spacing: unset;\r\n  margin-left: 10px;\r\n}\r\n\r\n.postTime-Feed {\r\n  color: #888;\r\n  text-align: center;\r\n}\r\n\r\n.card-Feed .card-body {\r\n  // padding: 10px 0 6px;\r\n  padding: 10px 8px 0;\r\n}\r\n\r\n.card-Feed .card-text {\r\n  font-size: 15px;\r\n  letter-spacing: 0.5px;\r\n  color: #3c4b64;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.mediaPhotoWrap-Feed,\r\n.mediaVideoWrap-Feed {\r\n  max-width: 100%;\r\n  width: 100%;\r\n  max-height: 100%;\r\n  overflow: hidden;\r\n  border-radius: 2px;\r\n  margin-bottom: 10px;\r\n  box-shadow: 0 1px 1px 0 rgba(60, 75, 100, 0.14),\r\n    0 2px 1px -1px rgba(60, 75, 100, 0.12), 0 1px 3px 0 rgba(60, 75, 100, 0.2);\r\n}\r\n\r\n.mediaPhotoWrap-Feed .carousel .carousel-item img,\r\n.mediaPhotoWrap-Feed .carousel .carousel-item video {\r\n  height: 375px;\r\n  width: 100%;\r\n}\r\n\r\n.mediaPhotoWrap-Feed .carousel .carousel-item img {\r\n  object-fit: cover;\r\n  object-fit: contain;\r\n}\r\n\r\n.mediaPhoto-Feed {\r\n  border-radius: 2px;\r\n  max-height: 100%;\r\n  max-width: 100%;\r\n  // width: auto;\r\n  // height: auto;\r\n  width: 100%;\r\n  height: 375px;\r\n  object-fit: cover;\r\n  object-fit: contain;\r\n  background: #f5f5f5;\r\n}\r\n\r\n.options-Feed {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\r\n  // padding-top: 10px;\r\n  padding: 10px 0;\r\n  border-bottom-left-radius: 8px;\r\n  border-bottom-right-radius: 8px;\r\n  margin: 0 -8px;\r\n  background-color: #f0f3f5;\r\n}\r\n\r\n.options-Feed span {\r\n  color: #1F1F1F;\r\n}\r\n\r\n.options-Feed .btn {\r\n  padding: 6px 12px;\r\n  line-height: 1;\r\n  font-size: 16px;\r\n  border: 1px solid transparent !important;\r\n  background: transparent !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.options-Feed .btn i {\r\n  margin-right: 8px;\r\n  vertical-align: -1px;\r\n  margin-top: 0 !important;\r\n}\r\n\r\n.carousel-control-prev,\r\n.carousel-control-next {\r\n  width: 9%;\r\n  height: 20%;\r\n  top: 40%;\r\n}\r\n\r\naudio:focus {\r\n  outline: 0;\r\n}\r\n\r\n.carousel-control-next-icon,\r\n.carousel-control-prev-icon {\r\n  cursor: pointer;\r\n}\r\n\r\n.customDropdown-Feed .nav-link {\r\n  color: #c8ced3;\r\n  padding: 6px 12px;\r\n  line-height: 1;\r\n  font-size: 16px;\r\n  border: 1px solid transparent !important;\r\n  background: transparent !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.customDropdown-Feed .nav-link:hover {\r\n  color: #23282c;\r\n}\r\n\r\n.pollOptionWrap label {\r\n  color: #777;\r\n  font-size: 15px;\r\n  letter-spacing: 0.3px;\r\n}\r\n\r\n.create-post-txt {\r\n  margin-bottom: 0;\r\n  color: #3c4b64;\r\n  letter-spacing: 0.3px;\r\n}\r\n\r\n.fansImgWrap {\r\n  min-width: 36px;\r\n  min-height: 36px;\r\n  width: 36px;\r\n  height: 36px;\r\n  overflow: hidden;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 50%;\r\n  padding: 2px;\r\n  margin-right: 8px;\r\n}\r\n\r\n.fansImg {\r\n  width: 30px;\r\n  min-width: 30px;\r\n  height: 30px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n}\r\n\r\n// msg preview\r\n.msgPreviewWrap {\r\n  width: calc(100% - 50px);\r\n  left: 0;\r\n  top: 0;\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  overflow-x: auto;\r\n  background: #fff;\r\n  padding: 8px 2px;\r\n  scrollbar-color: rgba(95, 66, 170, 0.6) #bbb;\r\n  scrollbar-width: thin;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  background: transparent;\r\n}\r\n\r\n.msgPreview {\r\n  width: 56px;\r\n  height: 56px;\r\n  min-width: 56px;\r\n  max-width: 56px;\r\n  padding: 2px;\r\n  border: 1px solid rgba(0, 0, 0, 0.1);\r\n  border-radius: 4px;\r\n  position: relative;\r\n  margin-right: 10px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.msgPreview-media {\r\n  width: 50px;\r\n  min-width: 50px;\r\n  max-width: 50px;\r\n  height: 50px;\r\n  object-fit: cover;\r\n  border-radius: 4px;\r\n}\r\n\r\n.deletePreview {\r\n  position: absolute;\r\n  padding: 4px 3px 2px;\r\n  font-size: 13px;\r\n  border-radius: 50%;\r\n  top: -7px;\r\n  right: -5px;\r\n  line-height: 1;\r\n  background: #de2727 !important;\r\n  box-shadow: none !important;\r\n  outline: 0 !important;\r\n  color: #fff !important;\r\n  border: 0;\r\n  text-align: center;\r\n}\r\n\r\n.msgPreviewWrap::-webkit-scrollbar-track {\r\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);\r\n  border-radius: 0;\r\n  background-color: #bbb;\r\n}\r\n\r\n.msgPreviewWrap::-webkit-scrollbar {\r\n  background-color: #bbb;\r\n  height: 6px;\r\n}\r\n\r\n.msgPreviewWrap::-webkit-scrollbar-thumb {\r\n  border-radius: 0;\r\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);\r\n  background-color: rgba(95, 66, 170, 0.6);\r\n}\r\n\r\n.messagePreview {\r\n  border: 1px solid rgba(0, 0, 0, 0.1);\r\n  padding: 8px 20px 8px 8px;\r\n  border-radius: 4px;\r\n  position: relative;\r\n  font-size: 16px;\r\n  line-height: 1;\r\n}\r\n\r\n// post locked\r\n.postLocked,\r\n.postUnlocked {\r\n  position: relative;\r\n}\r\n\r\n.postLockedOverlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(255, 255, 255, 0.95);\r\n  border-radius: 2px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  border: 1px solid #7e57c2;\r\n}\r\n\r\n// comment section - feed\r\n.commentSection {\r\n  background: #fff;\r\n  margin-bottom: 15px;\r\n  border-radius: 4px;\r\n  padding: 18px 10px 12px;\r\n  margin-top: -5px;\r\n  box-shadow: 0 1px 1px 0 rgba(60, 75, 100, 0.14),\r\n    0 2px 1px -1px rgba(60, 75, 100, 0.12), 0 1px 3px 0 rgba(60, 75, 100, 0.2);\r\n  max-height: 380px;\r\n  overflow: auto;\r\n  scrollbar-color: rgba(95, 66, 170, 0.8) #bbb;\r\n  scrollbar-width: thin;\r\n}\r\n\r\n.commentSection::-webkit-scrollbar-track {\r\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);\r\n  border-radius: 0;\r\n  background-color: #bbb;\r\n}\r\n\r\n.commentSection::-webkit-scrollbar {\r\n  width: 8px;\r\n  background-color: #bbb;\r\n}\r\n\r\n.commentSection::-webkit-scrollbar-thumb {\r\n  border-radius: 0;\r\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);\r\n  background-color: rgba(95, 66, 170, 0.8);\r\n}\r\n\r\n.personImg-Comment {\r\n  min-width: 32px;\r\n  min-height: 32px;\r\n  width: 32px;\r\n  height: 32px;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 50%;\r\n  margin-right: 8px;\r\n  font-size: 14px;\r\n  color: #3c4b64;\r\n}\r\n\r\n.commentSection .form-control {\r\n  background: #f5f8fd;\r\n}\r\n\r\n.comments-Post {\r\n  background: #f5f5f5;\r\n  border-radius: 4px;\r\n  padding: 6px;\r\n  font-size: 14px;\r\n  color: #3c4b64;\r\n  margin-bottom: 2px;\r\n  border: 1px solid #eee;\r\n}\r\n\r\n.comments-Post p {\r\n  font-size: 14px;\r\n  font-size: 14px;\r\n  color: #3c4b64;\r\n  letter-spacing: 0.5px;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.commentOptions .nav-link {\r\n  color: #888;\r\n  padding: 6px;\r\n  margin-left: 4px;\r\n  border-radius: 50%;\r\n  line-height: 1;\r\n  font-size: 13px;\r\n  background: transparent !important;\r\n  border: 1px solid rgba(0, 0, 0, 0.1) !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.commentOptions .nav-link i {\r\n  margin-top: 0 !important;\r\n}\r\n\r\n.replyBtn {\r\n  font-size: 13px;\r\n  color: #888;\r\n  letter-spacing: 0.5px;\r\n  padding: 4px 4px 2px;\r\n  margin: 0;\r\n  width: min-content;\r\n  background: transparent !important;\r\n  border: 0;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.commentTime {\r\n  padding: 4px 0 2px;\r\n  font-size: 13px;\r\n  color: #888;\r\n  letter-spacing: 0.5px;\r\n  margin-left: 15px;\r\n  position: relative;\r\n}\r\n\r\n.commentTime:before {\r\n  position: absolute;\r\n  top: 4px;\r\n  left: -12px;\r\n}\r\n\r\n.videoPlayBtn {\r\n  height: 50px;\r\n  width: 50px;\r\n  line-height: 1;\r\n  border: 1px solid #1F1F1F !important;\r\n  border-radius: 50%;\r\n  color: #1F1F1F !important;\r\n  font-size: 22px;\r\n  background: #fff !important;\r\n  box-shadow: 0 1px 1px 0 rgba(60, 75, 100, 0.14),\r\n    0 2px 1px -1px rgba(60, 75, 100, 0.12), 0 1px 3px 0 rgba(60, 75, 100, 0.2) !important;\r\n}\r\n\r\n.videoPlayBtn i {\r\n  margin-top: 0 !important;\r\n  margin-left: 3px;\r\n}\r\n\r\n// admin panel specific\r\n\r\n.ml-0 {\r\n  margin-left: 0 !important;\r\n}\r\n\r\n.mt-0{\r\n\tmargin-top: 0 !important;\r\n}\r\n\r\n.capitalize{\r\n  text-transform: capitalize;\r\n}\r\n\r\n\r\na {\r\n  color: inherit;\r\n  text-decoration: none;\r\n  &:hover {\r\n    color: inherit;\r\n    text-decoration: none;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
